import InfoBarHeaderMenu from "./InfoBarHeaderMenu";
export default class ChainSource extends React.Component {
  constructor(props) {
    super(props);
    this.totalViews = 2;
    this.differentViews = [];
    this.differentViews["PARTIAL"] = 1;
    this.differentViews["EXPANDED"] = 2;
    this.tabs = { SOURCE: "SOURCE", VOTE: "VOTE", CHANGE_LOG: "CHANGE_LOG" };
    this.info = {
      OBJECT_DATA: "OBJECT_DATA",
      OBJECT_REFERENCE: "OBJECT_REFERENCE",
      UPLOADED_FILES: "UPLOADED_FILES"
    };
    this.initState = {
      currentView: this.differentViews["PARTIAL"],
      currentTab: this.tabs.SOURCE,
      currentInfo: this.info.OBJECT_DATA,
      referenceInfoBox: false,
      objectInfoBox: false,
      materialType: [],
      selectedObject: null,
      showModal: false,
      modalHeader: "",
      modalContent: null,
      modalFooter: "",
      hideModalCloseIcon: false,
      hideShareButton: true,
      url: "",
      leftBar: this.initLeftBar,
      sourceCurrentInfoData: "",
      isSourceExpanded: false,
      isReferenceNumberExpanded: false,
      isReferenceExpanded: false
    };
    this.state = Object.assign({}, this.initState);
    this.ref = null;
    this.expand = this.expand.bind(this);
    this.showDetail = this.showDetail.bind(this);
    this.isSelected = this.isSelected.bind(this);
    this.collapse = this.collapse.bind(this);
    this.changeTab = this.changeTab.bind(this);
    this.getDateTime = this.getDateTime.bind(this);
    this.like = this.like.bind(this);
    this.dislike = this.dislike.bind(this);
    this.editSource = this.editSource.bind(this);
    this.deleteSource = this.deleteSource.bind(this);
    this.performLike = this.performLike.bind(this);
    this.isInfoVisible = this.isInfoVisible.bind(this);
    this.contextMenu = this.contextMenu.bind(this);
    this.toggleSourceInfoBox = this.toggleSourceInfoBox.bind(this);
    this.showUploadButton = this.showUploadButton.bind(this);
    this.shortenString = this.shortenString.bind(this);
    this.generateMenuItems = this.generateMenuItems.bind(this);
    this.setSelectedObject = this.setSelectedObject.bind(this);
    this.selectObject = this.selectObject.bind(this);
    this.openUploadForm = this.openUploadForm.bind(this);
    this.uploadForm = this.uploadForm.bind(this);
    this.expandSource = this.expandSource.bind(this);
    this.showMediaArchiveDetails = this.showMediaArchiveDetails.bind(this);
    this.createMediaArchive = this.createMediaArchive.bind(this);
    this.deleteMediaArchive = this.deleteMediaArchive.bind(this);
    this.viewMediaArchive = this.viewMediaArchive.bind(this);
    this.takeSnapshot = this.takeSnapshot.bind(this);
    this.previewSnapshot = this.previewSnapshot.bind(this);
    this.saveUploadFileWithHighlight = this.saveUploadFileWithHighlight.bind(
      this
    );
    this.setSelectedObject = this.setSelectedObject.bind(this);
    this.changeLogOfSelectedObject = this.changeLogOfSelectedObject.bind(this);
    this.editFormInfoBar = this.editFormInfoBar.bind(this);
    this.selectedChainIsPersonalOpinion = this.selectedChainIsPersonalOpinion.bind(
        this
      );
    this.objectInfoOfSelectedObject = this.objectInfoOfSelectedObject.bind(
        this
      );
    this.t = this.t.bind(this);
    this.showUploadedFileLink = this.showUploadedFileLink.bind(this);
    this.performUploadForm = this.performUploadForm.bind(this);
    this.highlightBox = this.highlightBox.bind(this);
    this.getHighlightAttributes = this.getHighlightAttributes.bind(this);
    this.menuItems = null;
    this.pageImages = [];
    this.dataI18nKeys = {
      show_file: "source-show-file",
      uploaded_at: "source-uploaded-at",
      file_size: "source-file-size",
      file_type: "source-file-type",
      verification_total_points: "source-verification-total-points",
      ver_no: "source-ver-no",
      ver_points: "source-ver-points",
      verification: "source-verification",
      username: "source-username",
      date_time: "source-date-time",
      new_value: "source-new-value",
      old_value: "source-old-value",
      fields: "source-fields",
      event: "source-event",
      time: "source-time",
      date: "source-date",
      source: "source-source",
      vote_count: "source-vote-count",
      vote: "source-vote",
      change_log: "source-change-log",
      reference: "source-reference",
      uploaded_file: "source-uploaded-file",
      menu_item_edit: "source-edit",
      menu_item_delete: "source-delete",
      menu_item_like: "source-this-data-is-true",
      menu_item_dislike: "source-this-data-is-false",
      click_to_expand: "source-click-to-expand",
      coming_soon: "source-coming-soon",
      upload: "source-upload",
      maxFilesExceeded: "source-max-files-exceeded",
      save: "source-save",
      remove: "source-remove",
      dropzone_default_message: "source-dropzone-default-message",
      snapshot: "source-take-snapshot",
      copyright_hint: "source-copyright-hint",
      copyright_placeholder: "source-copyright-placeholder",
      no_snapshot_message: "source-no-snapshot-message",
      timeout: "source-snapshot-timeout",
      close: "source-close",
      wait_msg: "source-wait-msg",
      copyright_invalid: "source-copyright-invalid-msg",
      snapshot_date_time: "source-date-time-snapshot",
      orignal_source_material: "source-orignal-source-material",
      orignal_source_material_type: "source-orignal-source-material-type",
      defaultdash: "source-dash",
      illustarion: "source-illustarion",
      digital_document: "source-digital-document",
      printed_material: "source-printed-material",
      photo: "source-photo",
      other: "source-other"
    };

    //Ref for reference block and details block
    this.wrapperRef = React.createRef();
    this.detailsBlockRef = React.createRef();
  }

  changeLogOfSelectedObject() {
    const viewId = this.props.selectedObject.viewId;
    const type = this.props.selectedObject.type;
    const id = this.props.selectedObject.id;
    var changeLog = [];
    if (type === globalFunctions.objectTypes.OBJECT) {
      changeLog = this.props.object.changeLog.filter((change) => {
        if (change.fields && typeof change.fields.chainId !== "undefined") {
          return false;
        }
        return true;
      });
    } else if (type === globalFunctions.objectTypes.SOURCE) {
      this.props.object.chains.some((chain) => {
        return chain.sources.some((source) => {
          if (source.viewId === viewId) {
            changeLog = source.changeLog;
            return true;
          }
          return false;
        });
      });
    } else if (type === globalFunctions.objectTypes.REFERENCE_NO) {
      this.props.object.referencePoint.filter((value) => {
        if(value.changeLog.length && value.viewId === viewId) {
           changeLog = value.changeLog;
           return true;
        }else{
          return false;
        }
      });
    }
    return changeLog;
  }

objectInfoOfSelectedObject() {
    const viewId = this.props.selectedObject.viewId;
    const type = this.props.selectedObject.type;
    const objectInfo = {};
    objectInfo.type = type;
    switch (type) {
      case globalFunctions.objectTypes.OBJECT:
        objectInfo.actualObjectData = Object.assign(
          {},
          this.props.object.actualObjectData
        );
        objectInfo.objectData = Object.assign({}, this.props.object.objectData);
        var keys = Object.keys(objectInfo.actualObjectData);
        delete objectInfo.actualObjectData[keys[keys.length - 1]];
        break;
      case globalFunctions.objectTypes.SOURCE:
        this.props.object.chains.some((chain) => {
          return chain.sources.some((source) => {
            if (source.viewId === viewId) {
              objectInfo.sourceData = Object.assign({}, source.sourceData);
              objectInfo.reference = Object.assign({}, source.reference);
              return true;
            }
            return false;
          });
        });
        break;
      case globalFunctions.objectTypes.REFERENCE:
        this.props.object.referencePoint.some((refPoint) => {
          if (refPoint.viewId === viewId) {
            objectInfo.referenceData = {};
            objectInfo.referenceData.viewId = refPoint.viewId;
            objectInfo.referenceData.title = refPoint.title;
            objectInfo.referenceData.value = refPoint.value;
            return true;
          }
          return false;
        });
        break;
    }
    return objectInfo;
  }

  getSelectedObject(key) {
    return this.state.selectedObject && this.state.selectedObject[key];
  }

selectedChainIsPersonalOpinion() {
    if (this.state.selectedObject === null) {
      return null; // currently no object is selected
    }
    if (
      this.state.selectedObject.type !==
        globalFunctions.objectTypes.REFERENCE &&
      this.state.selectedObject.type !==
        globalFunctions.objectTypes.REFERENCE_NO
    ) {
      return -1; // not reference
    }
    if (
      this.state.selectedObject.type ===
        globalFunctions.objectTypes.REFERENCE ||
      this.state.selectedObject.type ===
        globalFunctions.objectTypes.REFERENCE_NO
    ) {
      if (this.props.object.typeId === 5) {
        return 1; // reference and personal opinion
      }
      return 0; // reference but not personal opinion
    }
  }

editFormInfoBar() {
    var onChainFormResolved = (response) => {
      var extraInputs =
        '<input type="hidden" name="objectId" value="' +
        this.props.object.id +
        '">' +
        '<input type="hidden" name="referenceType" value="' +
        this.props.object.typeId +
        '">' +
        '<input type="hidden" name="chainId" value="' +
        this.state.selectedObject.id +
        '">' +
        '<button id="add-chain" class="ui button" type="button">Update</button>';
      if (response.isForm) {
        var reference = globalFunctions.getTranslatedMessage(
          this.dataI18nKeys[4],
          "Reference"
        );
        $("#sub-title-form-object").html(reference);
        $("#object-form").html(response.data + extraInputs);
      }
      this.afterFetchForm();
    };
    var isPO = this.selectedChainIsPersonalOpinion();
    return isPO !== null // an object is selected
      ? isPO === -1 // not reference
        ? () =>
            this.fetchEditForm(
              this.state.selectedObject.id,
              this.state.selectedObject.viewId
            )
        : isPO === 1 // reference and personal opinion
        ? () => undefined
        : () =>
            this.fetchChainForm(
              this.props.object.typeId,
              this.state.selectedObject.id
            ).then(onChainFormResolved, (rejected) =>
              console.log("Rejected = ", rejected)
            )
      : () => undefined;
  }

deleteObjectInfoBar() {
    var isPO = this.selectedChainIsPersonalOpinion();
    var selectedSourceType = this.getSelectedObject("type");
    return isPO !== null // an object is selected
      ? isPO === -1 // not reference
        ? (selectedSourceType !== globalFunctions.objectTypes.OPEN_POINT && selectedSourceType !== globalFunctions.objectTypes.END_POINT) ?
            () =>
            this.deleteObject(
              this.state.selectedObject.id,
              this.state.selectedObject.type ===
                globalFunctions.objectTypes.SOURCE
            )
            : () => this.deleteEndPoint()
        : () => this.deleteChain(this.state.selectedObject.id)
      : () => undefined;
  }

  componentDidMount() {
    for (var key in this.dataI18nKeys) {
      globalFunctions.applyTranslatedMessage(
        this.dataI18nKeys[key],
        "[data-i18n=" + this.dataI18nKeys[key] + "]"
      );
    }
    this.expandSource();
    if (typeof globalFunctions.openUploadForm === "undefined") {
      globalFunctions.openUploadForm = [];
    }
    const typeId = this.props.data.typeId;
    if (typeId === 1 || typeId === 2 || typeId === 3 || typeId === 12 || typeId === 13 || typeId === 14 || typeId === 4 || typeId === 5 || typeId === 8) {
      globalFunctions.openUploadForm[this.props.data.viewId] = (
        onSave = false
      ) => this.performUploadForm(onSave);
    }
    // if type is website and the chain is expanded, it means that new website source has been added
    if ((typeId === 6 || typeId === 9 || typeId === 10 || typeId === 11)&& this.props.expand) {
      let isProtected = _.get(this.props.data, "sourceData.Is Protected", "no");
      if (isProtected === "no" && this.props.data.mediaArchive !== undefined && this.props.data.mediaArchive !== null) {
        if(this.props.data.mediaArchive.status !== "completed" && this.props.data.mediaArchive.status !== "cancel"){
          const data = this.props.data;
          var url = data.sourceData['Url'];
          this.createMediaArchive(data.id, url);
        // console.log("taking snapshot");
        }
      }
    }
    let materialType = [
      this.dataI18nKeys.defaultdash,
      this.dataI18nKeys.illustarion,
      this.dataI18nKeys.digital_document,
      this.dataI18nKeys.printed_material,
      this.dataI18nKeys.photo,
      this.dataI18nKeys.other
    ];
    this.initState.materialType = materialType;
    this.tryEnableMediaArchiveUpdates();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // console.log("in component update of chain source")

    // if a website's url is changed then start the snapshot process
    const typeId = this.props.data.typeId;
    if (typeId === 6 || typeId === 9 || typeId === 10 || typeId === 11) {
      var data = this.props.data;
      var prevData = prevProps.data;
      var url = data.sourceData['Url'];
      var prevUrl = prevData.sourceData['Url'];
      if (url !== prevUrl) {
        this.createMediaArchive(data.id, url);
        return;
      }
    }
    const selectedObjectId = this.props.selectedObjectId;
    if (
      this.expandSource() &&
      prevProps.selectedObjectId !== -1 &&
      selectedObjectId === prevProps.selectedObjectId
    ) {
      // second condition is added for that object which is selected for the first time
      // console.log("directly return");
      return;
    }

    var currentViewChanged = prevState.currentView !== this.state.currentView;
    var currentInfoChanged = prevState.currentInfo !== this.state.currentInfo;
    if (
      prevState.currentTab !== this.state.currentTab ||
      currentInfoChanged ||
      currentViewChanged ||
      prevState.referenceInfoBox !== this.state.referenceInfoBox ||
      prevState.objectInfoBox !== this.state.objectInfoBox
    ) {
      // console.log("in component update of chain source - make height equal")
      this.props.makeHeightsEqual(this.props.classNameSelector);
    }

    const expand = this.props.expand;
    // update state only when selected object and this object are not same
    // moreover check that current state does not equal initState
    if (
      !expand &&
      // !this.isSelected() &&
      JSON.stringify(this.state) !== JSON.stringify(this.initState)
    ) {
      this.setState(this.initState);
      var classNameSelector = this.props.classNameSelector;
      setTimeout(function() {
        $(classNameSelector)
          .find(".simplebar-content")
          .scrollLeft(0);
      }, 100);
    }

    if (
      (this.isSelected() && selectedObjectId !== prevProps.selectedObjectId) || // this has been added to avoid unnecessary scrolling
      currentViewChanged
    ) {

      if (this.state.currentView === 2) {
        return;
      }
      // below code is taken from: http://blog.briteskies.com/blog/jquery-set-scroll-bar-to-center-on-element
      // and has been little bit modified to suit our needs
      var outer = $(this.ref).parents(".simplebar-content");
      var target = $(this.ref); //Lets assume one element has the class active, it is the one we want to center
      var containerWidth = outer.width();
      var targetWidth = target.outerWidth(true);
      var targetIndex = this.props.index; //Tells us what position this is in. Useful in calculations
      // console.log('print',this.props.data.viewId, this.state.currentView, targetWidth, containerWidth)
      var leftScreenOffset = (containerWidth - targetWidth) / 2;
      var leftSiblingOffset =
        this.state.currentView === this.differentViews["EXPANDED"]
          ? targetWidth + (targetWidth / 3) * (targetIndex - 1)
          : targetWidth * targetIndex;
      // console.log(this.props.data.viewId, this.state.currentView === this.differentViews['EXPANDED'])
      var scrollValue = leftSiblingOffset - leftScreenOffset;
      // this.performPushReplaceState();
      //outer.scrollLeft(Math.max(0, scrollValue)); // our target is now centered
      //globalFunctions.manageLeftAndRightArrows($(this.ref).parents(".content_box"));
    }
  }

  componentWillUnmount() {
    const viewId = this.props.data.viewId;
    if (typeof globalFunctions.openUploadForm[viewId] !== "undefined") {
      delete globalFunctions.openUploadForm[viewId];
    }
  }

  t(key, defaultMessage) {
    return globalFunctions.getTranslatedMessage(key, defaultMessage);
  }

  performLike(value) {
    var data = { object_id: this.props.data.id, value: value };
    $.ajax({
      type: "post",
      url: site_url + "/chain/vote",
      dataType: "json",
      data: data,
      success: function(response) {
        var message = response.message;
        var className = "";
        if (response.success) {
          globalFunctions.loadChain();
          className = "positive";
          message = "<p>" + message + "</p>";
        } else {
          className = "negative";
          message = response.message
            .split("<br>")
            .map(error => "<li>" + error + "</li>")
            .join("");
        }
        var messageHTML =
          '<div id="message" className="ui ' +
          className +
          ' message">' +
          '<i className="close icon close-message"></i>' +
          message +
          "</div>";
        $("#show-object-container #message").remove();
        $(messageHTML).insertBefore("#show-object-container #show-object");
        $("html, body").animate({ scrollTop: 0 }, "slow");
      },
      error: function(jqxhr, status, exception) {
        console.log(exception);
        console.log(status);
        console.log(jqxhr);
      }
    });
  }

  dislike() {
    this.performLike(0);
  }

  like() {
    this.performLike(1);
  }

  editSource(e) {
    e.stopPropagation();
    this.editSourceObject();
    this.props.fetchForm(this.props.data.id, this.props.data.viewId);
  }

  editSourceObject (e) {
    this.setSelectedObject();
    if (this.state.currentInfo === "OBJECT_DATA") {
      this.toggleSourceInfoBox(e, "objectInfoBox", this.info.OBJECT_DATA);
    } else if (this.state.currentInfo === "OBJECT_REFERENCE") {
      this.toggleSourceInfoBox(
        e,
        "referenceInfoBox",
        this.info.OBJECT_REFERENCE
      );
    }
  }

  deleteSource() {
    this.props.delete(this.props.data.id);
  }

  getDateTime(timestamp, format = "dt") {
    var d = new Date(timestamp);
    var addLeadingZero = (val) => (val < 10 ? "0" : "") + val;
    if (/^d$/.test(format)) {
      return (
        d.getFullYear() +
        "-" +
        addLeadingZero(d.getMonth() + 1) +
        "-" +
        addLeadingZero(d.getDate())
      );
    } else if (/^t$/.test(format)) {
      return (
        addLeadingZero(d.getHours()) +
        ":" +
        addLeadingZero(d.getMinutes()) +
        ":" +
        addLeadingZero(d.getSeconds())
      );
    }
    return (
      d.getFullYear() +
      "-" +
      addLeadingZero(d.getMonth() + 1) +
      "-" +
      addLeadingZero(d.getDate()) +
      " " +
      addLeadingZero(d.getHours()) +
      ":" +
      addLeadingZero(d.getMinutes())
    );
  }

  expand(value = -1) {
    this.setState(state => ({
      currentView:
        value === -1 ? (state.currentView + 1) % this.totalViews : value
    }));
  }

  showDetail(value) {
    // e.stopPropagation();
    let isProtected = _.get(this.props.data, "sourceData.Is Protected", "no");
    //if(!this.isSelected() || isProtected === 'yes') { return; }
    if (isProtected === "yes") {
      return;
    }
    var objectid = this.props.data.viewId;
    // $("#"+objectid +" .object-div").first().addClass("selected");
    if(this.props.sourceCurrentInfo == 'OBJECT_DATA'){
      $("#"+objectid +" .object-div").first().addClass("selected");
    }
    if(this.props.sourceCurrentInfo == 'OBJECT_REFERENCE'){
      $("#"+objectid +" .object-div").eq(1).addClass("selected");
    }

    this.expand(this.differentViews["EXPANDED"]);
    this.setState(state => ({
      currentInfo: value
    }));
    //added to show hide form fields
    this.props.setChainContainerState({ sourceCurrentInfo: value });
    if((this.props.index === this.props.totalSources || this.props.lastObject == 0)  || (this.props.lastObject == this.props.totalSources && this.props.selectedObjectId != -1)){
      $("#"+objectid).parents(".right_col").removeClass("lastObject");
      $("#"+objectid).parents(".right_col").siblings(".left_col").removeClass("lastObject");
    }
  }

  collapse(e) {
    // if(this.state.currentTab === this.tabs.SOURCE){
    this.expand(this.differentViews["PARTIAL"]);
    this.changeTab(e, this.tabs.SOURCE);
    this.props.setChainContainerState({ sourceCurrentInfo: null });
    // console.log(this.props.selectedObjectId + " " + this.state.currentView);
    // if((this.props.index === this.props.totalSources || this.props.lastObject == 0) || (this.props.lastObject == this.props.totalSources && this.props.selectedObjectId != -1)){
    //   var objectid = this.props.data.viewId;
    //   $("#"+objectid).parents(".right_col").addClass("lastObject");
    //   $("#"+objectid).parents(".right_col").siblings(".left_col").addClass("lastObject");
    // }
  }

  changeTab(e, selectedTab) {
    e.stopPropagation();
    this.setState(
      state => (
        {
          currentTab: selectedTab
        },
        () => console.log("currentTab", this.state.currentTab)
      )
    );
  }

  expandSource() {
    // const expand = this.props.expand;
    // const { referenceInfoBox, objectInfoBox, currentView } = this.state;
    // if (expand && !(referenceInfoBox && objectInfoBox)) {
    //   this.setState({ referenceInfoBox: true, objectInfoBox: true });
    //   return true;
    // } else if (
    //   expand &&
    //   !this.isSelected() &&
    //   currentView === this.differentViews["EXPANDED"]
    // ) {
    //   this.setState({
    //     currentView: this.differentViews["PARTIAL"],
    //     referenceInfoBox: true,
    //     objectInfoBox: true
    //   });
    //   return true;
    // }
    // return false;
  }

  isInfoVisible(infoValue) {
    return this.state.currentInfo === infoValue;
  }

  generateMenuItems() {
    this.menuItems = [];
    var isOwner = this.props.isOwner;
    var data = this.props.data;
    var voteExists = !isOwner ? data.voteExists : false;
    var isVoteable = this.props.isVoteable;
    var likeCheck, dislikeCheck;

    if (voteExists === 0) {
      likeCheck = <i className="icon" />;
      dislikeCheck = <i className="icon check" />;
    } else if (voteExists === 1) {
      likeCheck = <i className="icon check" />;
      dislikeCheck = <i className="icon" />;
    } else {
      likeCheck = dislikeCheck = null;
    }
    this.menuItems.push(
      <li key={data.viewId + "-menu-header"} className="header">
        Id: {data.viewId}
      </li>
    );
    let isProtected = _.get(this.props.data, "sourceData.Is Protected", "no");
    if (isOwner) {
      if (isProtected !== "yes") {
        this.menuItems.push(
          <li
            key={data.viewId + "-like"}
            className="item display-edit-object-form"
            onClick={this.editSource}
          >
            <i className="pencil icon custom-font-size"></i>
            <span data-i18n={this.dataI18nKeys.menu_item_edit}>Edit</span>
          </li>
        );
      }

      this.menuItems.push(
        <li
          key={data.viewId + "-dislike"}
          className="item"
          onClick={this.deleteSource}
        >
          <i className="trash alternate outline icon custom-font-size"></i>
          <span data-i18n={this.dataI18nKeys.menu_item_delete}>Delete</span>
        </li>
      );
    } else {
      const strComingSoonMsg = this.t(
        this.dataI18nKeys.coming_soon,
        "Coming soon"
      );
      if (isVoteable) {
        // this.like -> performs like, this.dislike -> performs dislike
        //{likeCheck} {dislikeCheck}
        this.menuItems.push(
          <li
            key={data.viewId + "-like"}
            className="item"
            onClick={() => alert(strComingSoonMsg)}
          >
            <span data-i18n={this.dataI18nKeys.menu_item_like}>
              This data is true
            </span>
          </li>
        );
        this.menuItems.push(
          <li
            key={data.viewId + "-dislike"}
            className="item"
            onClick={() => alert(strComingSoonMsg)}
          >
            <span data-i18n={this.dataI18nKeys.menu_item_dislike}>
              This data is false
            </span>
          </li>
        );
      } else {
        // className="item disabled"
        this.menuItems.push(
          <li
            key={data.viewId + "-like"}
            className="item"
            onClick={() => alert(strComingSoonMsg)}
          >
            <span data-i18n={this.dataI18nKeys.menu_item_like}>
              This data is true
            </span>
          </li>
        );
        this.menuItems.push(
          <li
            key={data.viewId + "-dislike"}
            className="item"
            onClick={() => alert(strComingSoonMsg)}
          >
            <span data-i18n={this.dataI18nKeys.menu_item_dislike}>
              This data is false
            </span>
          </li>
        );
      }
    }
  }

  contextMenu(e) {
    e.preventDefault();
    $(e.target)
      .parents(".chain-source")
      .find(".context-menu")
      .toggle(0, function() {
        $(this).css({ height: "initial" });
        var parentOffset = $(e.target)
          .parents(".chain-source")
          .offset();
        var parentHeight = $(e.target)
          .parents(".chain-source")
          .height();
        var mousePointer =
          e.pageY < parentOffset.top
            ? parentOffset.top - e.pageY
            : e.pageY - parentOffset.top;
        var heightOfMenu = $(this).height();
        var top = 0;

        if (parentHeight - mousePointer > heightOfMenu) {
          //there's enough space below
          top = mousePointer;
        } else if (mousePointer > heightOfMenu) {
          //there's enough space above
          top = mousePointer - heightOfMenu;
        } else {
          //there's neither enough space above nor below, so we'll place the menu wherever there is more room available
          if (parentHeight - mousePointer > mousePointer) {
            //there's more room available below
            $(this).css({ height: parentHeight - mousePointer + "px" });
            top = mousePointer;
          } else {
            //there's more room available above
            $(this).css({ height: mousePointer + "px" });
            top = 0;
          }
        }
        var left = e.screenX - parentOffset.left;
        $(this).css({ top: top + "px", left: left + "px" });
      });
  }

  shortenString(str) {
    return typeof str === "string" && str.length > 30
      ? str.substring(0, 30).trim() + ".."
      : str;
  }

  toggleSourceInfoBox(e, key, detailWindow) {
    //if(!this.isSelected()) { return; }
    /* this.setState(state => ({
            [key]: !state[key]
        })); */

        //When clicked on reference block first time, prevent parent(OBJECT_DATA) click trigger
    let isProtected = _.get(this.props.data, "sourceData.Is Protected", "no");
    if (isProtected === "no") {
      if (!(this.wrapperRef && this.wrapperRef.current.contains(event.target) && detailWindow !== 'OBJECT_REFERENCE') && !(this.detailsBlockRef && this.detailsBlockRef.current.contains(event.target))) {
        this.showDetail(detailWindow);        
      }    
    } 
  }

  selectObject(e) {
      if(this.props.isLoggedIn == 1){
        if(this.props.data.sourceData['Is Protected'] == "yes"){
          $('#infobar #selected-object-id_Delete').removeClass('hide');
          $('#infobar #selected-object-id_Delete').addClass('show');
        }else if(this.props.data.sourceData['Is Protected'] == "no"){
          $('#infobar #selected-object-id_Edit').removeClass('hide');
          $('#infobar #selected-object-id_Edit').addClass('show');
          $('#infobar #selected-object-id_Delete').removeClass('hide');
          $('#infobar #selected-object-id_Delete').addClass('show');
        }
      }
      
     var vId = this.props.data.viewId;
     var sourceClassName = $("#"+vId).parents('.four.wide.column.chain-source').attr('class').includes('is_protected');
     
      if(sourceClassName == false){
        $("#"+vId+" .detail-block").removeClass('hide');
        $("#"+vId+" .detail-block").addClass('show');
      }
        // $('#'+vId+' .object-div').first().addClass('selected');
    e.stopPropagation();
    this.performPushReplaceState();
    this.setSelectedObject();
  }

  performPushReplaceState() {
    var objID = this.props.data.viewId;
    var objectID = objID.split('-');
    var mainObjUrl = {'objUrl' : objectID[0]};
    var lastSegment = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
    
    if(window.location.href.indexOf("?url=") === -1){
      if(objectID[0] != lastSegment && $("#hidden1").val() != 'image') {
        window.history.replaceState(window.location.href,'ObjURL',objID);
      } else if($("#hidden1").val() != 'image'){
        window.history.pushState(mainObjUrl,'Main',objID);
      }
    }
    if(this.props.data.sourceData['Is Protected'] == "no"){
    this.setState({currentView: 2});
    }
  }

  setSelectedObject() {
    const hasNotes =
      _.get(this.props.data, "sourceData.Notes", false) ||
      _.get(this.props.data, "reference.Notes", false) ||
      false;
    this.props.setSelectedObject({
      viewId: this.props.data.viewId,
      id: this.props.data.id,
      type: globalFunctions.objectTypes.SOURCE,
      sourceTypeId: this.props.data.typeId,
      isProtected: _.get(this.props.data, "sourceData.Is Protected", "no"),
      hasNotes: !!hasNotes && hasNotes !== "-",
    });
  }

  isSelected() {
    return this.props.selectedObjectId === this.props.data.viewId;
  }

  showUploadButton() {
    const typeId = this.props.data.typeId;
    const isOwner = this.props.isOwner;
    if (isOwner && (typeId === 1 || typeId === 2 || typeId === 3 || typeId === 4 || typeId === 5 || typeId === 8 || typeId === 12 || typeId === 13 || typeId === 14)) {
      //1 - article, 2 - book, 3 - event, 4 - movie, 8 - essay, 5 - personal opinion
      return (
        <button
          data-i18n={this.dataI18nKeys.upload}
          onClick={this.openUploadForm}
          className="ui primary button upload-button"
        />
      );
    }
    return null;
  }

  uploadForm() {
    //const {materialType} = this.state;
    let materialType = [
      this.dataI18nKeys.defaultdash,
      this.dataI18nKeys.illustarion,
      this.dataI18nKeys.digital_document,
      this.dataI18nKeys.printed_material,
      this.dataI18nKeys.photo,
      this.dataI18nKeys.other
    ];
    let defaultValueIndex = "";
    let materialOptions = materialType.map((type, index) => {
      if(this.t(type) == _.get(this.props.data,'sourceData.Source Material Type')){
        defaultValueIndex = index.toString();
      }
      return (
        <option key={"material-option" + index} value={index}>
          {this.t(type)}
        </option>
      );
    });
    return (
      <div>
        <div id="modal-input-file-controller" className="ui input">
          <input type="file" />
        </div>
        <form
          action={site_url + "/chain/file_upload"}
          className="dropzone"
          id="modal-file-uploader"
        >
          <input
            type="hidden"
            name="_csrf"
            value={$('meta[name="csrf-token"]').attr("content")}
          />
          <input type="hidden" name="source_id" value={this.props.data.id} />
          <input
            defaultValue={_.get(this.props.data, "sourceData.Comment", "")}
            type="hidden"
            name="comment"
            id="upload-comment"
          />
          <input
            defaultValue={defaultValueIndex}
            type="hidden"
            name="source_material_type"
            id="upload-source-material-type"
          />
        </form>

        <div id="dropzone-buttons">
          <div style={{ marginBottom: "5px" }} className="material-source">
            <div style={{ marginBottom: "5px", float: "left" }}>
              {this.t(this.dataI18nKeys.orignal_source_material_type, "")}:
            </div>
            <select
              defaultValue={defaultValueIndex}
              style={{ width: "100%" }}
              className="ui dropdown"
              onChange={e =>
                $("#upload-source-material-type").val(e.target.value)
              }
            >
              {materialOptions}
            </select>
          </div>

          <div id="file-comment-wrap">
            <div style={{ marginBottom: "5px", float: "left" }}>Comment: </div>
            <textarea
              defaultValue={_.get(this.props.data, "sourceData.Comment", "")}
              onChange={e => $("#upload-comment").val(e.target.value)}
              style={{ marginBottom: "5px" }}
              id="file-comment"
              name="comment"
              className="file-comment"
            ></textarea>
          </div>
          <button className="ui primary button" id="upload-file">
            {this.t(this.dataI18nKeys.save, "Save")}
          </button>
          <button className="ui negative button" id="remove-file">
            {this.t(this.dataI18nKeys.remove, "Remove")}
          </button>
        </div>
        <div id="modal-file-uploader-status">
          <div className="ui indicating progress" id="upload-progress">
            <div className="bar">
              <div className="progress"></div>
            </div>
            <div className="label"></div>
          </div>
          <div className="ui message" id="file-drag-upload-message">
            <p></p>
          </div>
        </div>
      </div>
    );
  }

  openUploadForm(e) {
    e.stopPropagation();
    this.performUploadForm();
  }

  saveUploadFileWithHighlight(e, imageUrl) {
    var [top, height, width, left] = this.getHighlightAttributes();
    this.props.toggleModalCloseIcon();
    var _this = this;
    var objectId = this.props.data.viewId;
    $("#highlight-msg").removeClass("error success");
    $("#highlight-msg").text("");
    $("#preview-snapshot").addClass("loading disabled");
    $("#preview-cancel-snapshot").addClass("disabled");
    var selectedPage = imageUrl;
    var selectedPrev = "";
    var selectedNext = "";
    if (
      $("select#page-dropdown").length > 0 &&
      $("select#page-dropdown").val()
    ) {
      selectedPage = "uploads/" + $("select#page-dropdown").val() + ".jpeg";
      if ($("select#page-dropdown option:selected").prev().length > 0) {
        selectedPrev =
          "uploads/" +
          $("select#page-dropdown option:selected")
            .prev()
            .val() +
          ".jpeg";
      }
      if ($("select#page-dropdown option:selected").next().length > 0) {
        selectedNext =
          "uploads/" +
          $("select#page-dropdown option:selected")
            .next()
            .val() +
          ".jpeg";
      }
    }
    $.ajax({
      type: "post",
      url: site_url + "/chain/save-file-highlight",
      dataType: "json",
      data: {
        top: top,
        height: height,
        width: width,
        left: left,
        path: selectedPage,
        objectId,
        prevImage: selectedPrev,
        nextImage: selectedNext
      },
      success: function(response) {
        $("#highlight-msg").text(response.message);
        $("#preview-snapshot, #preview-cancel-snapshot").removeClass(
          "loading disabled"
        );
        if (response.success) {
          $("#highlight-msg").addClass("success");
          setTimeout(function() {
            _this.props.toggleModalCloseIcon();
            _this.props.closeModal();
            globalFunctions.loadChain();
          }, 1000);
        } else {
          $("#highlight-msg").addClass("error");
        }
      },
      error: function(jqxhr, status, exception) {
        console.log(exception, status, jqxhr);
      }
    });
  }

  performUploadForm(onSave = false) {
    const header = this.t(this.dataI18nKeys.upload, "Upload file");
    const content = this.uploadForm();
    this.props.showUploadFormModal(header, content);
    var _thisChainSource = this;
    setTimeout(() => {
      var windowWidth = $(window).width();
      if(windowWidth <= 460){
        $("#modal-file-uploader")
        .parents(".chain-modal-content")
        .css("width", "80%");
      }else{
        $("#modal-file-uploader")
          .parents(".chain-modal-content")
          .css("width", "40%");
      }
      Dropzone.autoDiscover = false;
      var element = document.getElementById("modal-file-uploader");
      var progressBar = $("#upload-progress");
      var fileUpload = new Dropzone(element, {
        maxFilesize: 50, // 50MB
        maxFiles: 1,
        thumbnailWidth: null,
        thumbnailHeight: null,
        clickable: false,
        autoProcessQueue: false,
        timeout: 600000,
        dictDefaultMessage: this.t(
          this.dataI18nKeys.dropzone_default_message,
          "Drop files here to upload"
        ),
        success: function(file, response) {
          var parsedResponse = JSON.parse(response);
          $("#file-drag-upload-message").removeClass("positive negative");
          $("#file-drag-upload-message").addClass(
            parsedResponse.success ? "positive" : "negative"
          );
          $("#file-drag-upload-message > p").text(parsedResponse.message);
          $("#file-drag-upload-message").css({ display: "block" });
          if (parsedResponse.success) {
            setTimeout(() => {
              // _thisChainSource.props.closeModal();
              // globalFunctions.loadChain();
              var onSave = e =>
                _thisChainSource.saveUploadFileWithHighlight(
                  e,
                  parsedResponse.image_url
                );
              var onCancel = () => {
                _thisChainSource.props.closeModal();
                globalFunctions.loadChain();
              };
              var imgUrl = parsedResponse.image_url;
              var otherImages = parsedResponse.other_images;
              this.pageImages = otherImages;
              var [
                content,
                footer,
                afterDisplaying
              ] = _thisChainSource.highlightBox(
                imgUrl,
                onSave,
                onCancel,
                otherImages
              );
              _thisChainSource.props.showSnapshotModal(
                _thisChainSource.t(_thisChainSource.dataI18nKeys.uploaded_file),
                content,
                footer
              );
              afterDisplaying();
              delete globalFunctions.onModalClose;
              $("#upload-file").removeClass("disabled loading");
              $("#remove-file").removeClass("disabled");
              setTimeout(function() {
                // add image highlight
                globalFunctions.addHighImageHighlight(
                  $("#snapshot-modal #snapshot-image")
                );
                $("#chain-modal").css("padding-top", "0px");
                $("#chain-modal .chain-modal-content").css({
                  height: "100vh",
                  margin: "0",
                  border: "0px",
                  "border-radius": "0px",
                  width: "auto"
                });
                $(".chain-modal-content .chain-modal-header").css(
                  "height",
                  "9%"
                );
                $(".chain-modal-content .chain-modal-footer").css(
                  "height",
                  "9%"
                );
                $(".chain-modal-content #content").css(
                  "max-height",
                  "calc(100% - 18%)"
                );
                $(".chain-modal-content #content").addClass('noHeightCss');
              }, 15);
            }, 1000);
          } else {
            $("#upload-file").removeClass("disabled loading");
            $("#remove-file").removeClass("disabled");
            $("#upload-progress").removeClass("success");
            $("#upload-progress").addClass("error");
          }
        },
        error: function(file, errorMessage) {
          // alert("error");
          $("#upload-file").removeClass("disabled loading");
          $("#remove-file").removeClass("disabled");
          $("#upload-progress").removeClass("success");
          $("#upload-progress").addClass("error");
        },
        sending: function(file) {
          $("#upload-file").addClass("disabled loading");
          $("#remove-file").addClass("disabled");
          $("#upload-progress").removeClass("error");
          $("#upload-progress").addClass("success");
        },
        init: function() {
          this.on("maxfilesexceeded", function(file) {
            this.removeFile(file);
            $("#file-drag-upload-message").removeClass("positive negative");
            $("#file-drag-upload-message").addClass("negative");
            $("#file-drag-upload-message > p").text(
              _thisChainSource.t(
                _thisChainSource.dataI18nKeys.maxFilesExceeded,
                "You can only upload one file at a time"
              )
            );
            $("#file-drag-upload-message").css({ display: "block" });
          });
          progressBar.progress({ total: 100, percent: 0 });
          // console.log("init, progressBar.length = ", progressBar.length)
        },
        uploadprogress: function(file, progress, bytesent) {
          progressBar.progress({ percent: progress });
        }
      });
      $(".dropzone + #dropzone-buttons > #upload-file").click(function() {
        if (fileUpload.length === 0) {
          return;
        }
        fileUpload.processQueue();
      });
      $(".dropzone + #dropzone-buttons > #remove-file").click(function() {
        if ($("#modal-input-file-controller input[type=file]").val() !== "") {
          $("#modal-input-file-controller input[type=file]").val("");
        }
        fileUpload.removeAllFiles();
      });
      $("#modal-input-file-controller input[type=file]").on(
        "change",
        function() {
          fileUpload.removeAllFiles();
          var input = $(this)[0];
          var reader = new FileReader();
          reader.onload = function(e) {
            // if file type is image, only then generate thumbnail
            if (/^image/.test(input.files[0].type)) {
              fileUpload.emit("thumbnail", input.files[0], e.target.result);
            }
          };
          fileUpload.emit("addedfile", input.files[0]);
          input.files[0].upload = {
            uuid: Dropzone.uuidv4(),
            progress: 0,
            total: input.files[0].size,
            bytesSent: 0,
            filename: input.files[0].name
          };
          input.files[0].status = Dropzone.QUEUED;
          fileUpload.files.push(input.files[0]);
          reader.readAsDataURL(input.files[0]);
        }
      );
    }, 50);
  }

  showMediaArchiveDetails(setCitation) {
    const typeId = this.props.data.typeId;
    const id = this.props.data.id;
    const isOwner = this.props.isOwner;
    const url = _.get(this.props.data, "sourceData.Url", "");
    const mediaArchive = this.props.data.mediaArchive;
    if (isOwner && (typeId === 6 || typeId === 9 || typeId === 10 || typeId === 11) && mediaArchive != null) {
      // && setCitation === 0
      if(this.props.isLoggedIn == 1){
        return (
          <div style={{display : "flex"}}>
            <p style={{marginRight : "10px"}}>{this.getDateTime(mediaArchive.createdAt*1000)}</p>
            <a href={site_url + "/"+this.props.data.viewId + "?url=" + url} style={{marginRight : "7px",cursor : "pointer"}} onClick={e => this.viewMediaArchive(e)}>Show</a>
            <a style={{marginRight : "7px",cursor : "pointer"}} onClick={e => this.createMediaArchive(id, url)}>Retake</a>
            <a style={{cursor : "pointer"}} onClick={e => this.deleteMediaArchive(id)}>Delete</a>
          </div>
        );
      }else{
        return (
          <div style={{display : "flex"}}>
            <p style={{marginRight : "10px"}}>{this.getDateTime(mediaArchive.createdAt*1000)}</p>
            <a style={{marginRight : "7px",cursor : "pointer"}} onClick={e => this.viewMediaArchive(e)}>Show</a>
          </div>
        );
      }
    }
    //  commented code for links should be enabled after citation set
    // else if (isOwner && (typeId === 6 || typeId === 9 || typeId === 10 || typeId === 11) && mediaArchive != null && setCitation === 1) {
    //   return (
    //     <div style={{display : "flex"}}>
    //       <p style={{marginRight : "10px"}}>{this.getDateTime(mediaArchive.createdAt*1000)}</p>
    //       <p style={{marginRight : "7px",cursor : "pointer"}} >Show</p>
    //       <p style={{marginRight : "7px",cursor : "pointer"}} >Retake</p>
    //       <p style={{cursor : "pointer"}} >Delete</p>
    //     </div>
    //   ); 
    // }
    else if (!isOwner && (typeId === 6 || typeId === 9 || typeId === 10 || typeId === 11) && mediaArchive != null) {
      return (
        <div>
          <p>Created: {this.getDateTime(mediaArchive.createdAt*1000)}</p>
          <a style={{cursor : "pointer"}} onClick={e => this.viewMediaArchive(e)}>Show</a><br></br>
        </div>
      );
    }
    else if (isOwner && (typeId === 6 || typeId === 9 || typeId === 10 || typeId === 11)) {
      return (
        <div>
          <a style={{cursor : "pointer"}} onClick={e => this.createMediaArchive(id, url)}>Create</a>
        </div>
      );
    }
    return null;
  }

  tryEnableMediaArchiveUpdates() {
    const typeId = this.props.data.typeId;
    const objectId = this.props.data.viewId.split("-")[0];
    const sourceId = this.props.data.viewId;

    if (![6, 9, 10, 11].includes(typeId)) {
      return;
    }

    const _this = this;
    const xhr = $.ajax({
      type: "post",
      url: site_url + "/chain/object_data",
      dataType: "json",
      data: { id: objectId },
      timeout: 10000,
      success: function(response) {
        response.object.chains.forEach(chain => {
          chain.sources.forEach(source => {
            if (source.viewId == sourceId) {
              _this.props.data.mediaArchive = source.mediaArchive;
              _this.forceUpdate();
              if (source.mediaArchive != null && source.mediaArchive.status == "in_progress") {
                setTimeout(() => _this.tryEnableMediaArchiveUpdates(), 5000);
              }
            }
          })
        })
      },
      error: function(jqxhr, status, exception) {
        console.error(exception, status, jqxhr);
      }
    });
  }

  createMediaArchive(objectId, url) {
    const _this = this;
    const xhr = $.ajax({
      type: "post",
      url: site_url + "/chain/create-media-archive",
      dataType: "json",
      data: { objectId: objectId, url: url },
      timeout: 60000,
      success: function(response) {
        if (response.success) {
          _this.tryEnableMediaArchiveUpdates();
        }
      },
      error: function(jqxhr, status, exception) {
        console.log(exception, status, jqxhr);
      }
    });
  }

  cancelMediaArchive(e){
    const objectId = this.props.data.id;
    const url = _.get(this.props.data, "sourceData.Url", "");
    const _this = this;
    const xhr = $.ajax({
      type: "post",
      url: site_url + "/chain/cancel-media-archive",
      dataType: "json",
      data: { objectId: objectId, url: url },
      timeout: 60000,
      success: function(response) {
        if (response.success) {
          _this.tryEnableMediaArchiveUpdates();
        }
      },
      error: function(jqxhr, status, exception) {
        console.log(exception, status, jqxhr);
      }
    });
    this.showMediaArchiveInfo(this.props.data.mediaArchive);
    // const objectId = this.props.data.id;
    // const _this = this;
    // const xhr = $.ajax({
    //   type: "post",
    //   url: site_url + "/chain/media-archive-hook",
    //   dataType: "json",
    //   data: { objectId: objectId },
    //   timeout: 60000,
    //   success: function(response) {
    //     if (response.success) {
    //       _this.tryEnableMediaArchiveUpdates();
    //     }
    //   },
    //   error: function(jqxhr, status, exception) {
    //     console.log(exception, status, jqxhr);
    //   }
    // });
  }

  deleteMediaArchive(objectId) {
    const _this = this;
    const xhr = $.ajax({
      type: "post",
      url: site_url + "/chain/delete-media-archive",
      dataType: "json",
      data: { objectId: objectId },
      timeout: 60000,
      success: function(response) {
        if (response.success) {
          _this.props.data.mediaArchive = null;
          _this.forceUpdate();
        }
      },
      error: function(jqxhr, status, exception) {
        console.log(exception, status, jqxhr);
      }
    });
  }

  viewMediaArchive(e) {
    const mediaArchive = this.props.data.mediaArchive;
    if (mediaArchive == null) {
      return;
    }
    const viewId = encodeURIComponent(this.props.data.viewId);
    const archived = encodeURIComponent(this.getDateTime(mediaArchive.createdAt*1000));
    const url = encodeURIComponent(this.props.data.sourceData['Url']);
    const decoded = decodeURIComponent(url);
    const archiveUrl = encodeURIComponent(mediaArchive.archiveUrl);
    var screenshotUrl = "";
    if(this.props.data.uploadedFile.url != "" && this.props.data.uploadedFile.url != undefined){
      screenshotUrl = encodeURIComponent(site_url + "/" + this.props.data.uploadedFile.url + "?q=" + new Date().getTime());
    }else{
      screenshotUrl = encodeURIComponent(mediaArchive.screenshotUrl);
    }
    const neededUrl = `mediaArchiveViewer.php?viewid=${viewId}&archived=${archived}&url=${url}&archiveurl=${archiveUrl}&screenshoturl=${screenshotUrl}`;
    const urlForModal = `?url=${decoded}`;
    // window.open(`${site_url}/mediaArchiveViewer.php?viewid=${viewId}&archived=${archived}&url=${url}&archiveurl=${archiveUrl}&screenshoturl=${screenshotUrl}`);
    
    this.showUploadedArchiveFile(e, neededUrl, urlForModal);
  }

  setCitation(e){
          const _this = this;
          const xhr = $.ajax({
            type: "post",
            url: site_url + "/chain/file_upload_archive",
            dataType: "json",
            data: { source_id: this.props.data.id, comment: null, source_material_type: null },
            timeout: 60000,
            success: function(data) {
              var parsedResponse = data;
              var _thisChainSource = this;
              $("#file-drag-upload-message").removeClass("positive negative");
              $("#file-drag-upload-message").addClass(
                parsedResponse.success ? "positive" : "negative"
              );
              $("#file-drag-upload-message > p").text(parsedResponse.message);
              $("#file-drag-upload-message").css({ display: "block" });
              if (parsedResponse.success) {
                setTimeout(() => {
                  // _thisChainSource.props.closeModal();
                  // globalFunctions.loadChain();
                  var onSave = e =>
                    _this.saveUploadFileWithHighlight(
                      e,
                      parsedResponse.image_url
                    );
                  var onCancel = () => {
                    _this.props.closeModal();
                    globalFunctions.loadChain();
                  };
                  var imgUrl = parsedResponse.image_url;
                  var otherImages = null;
                  this.pageImages = otherImages;
                  var [
                    content,
                    footer,
                    afterDisplaying
                  ] = _this.highlightBox(
                    imgUrl,
                    onSave,
                    onCancel,
                    otherImages
                  );
                  _this.props.showSnapshotModal(
                    'Set citation',
                    content,
                    footer
                  );
                  afterDisplaying();
                  delete globalFunctions.onModalClose;
                  $("#upload-file").removeClass("disabled loading");
                  $("#remove-file").removeClass("disabled");
                  setTimeout(function() {
                    // add image highlight
                    globalFunctions.addHighImageHighlight(
                      $("#snapshot-modal #snapshot-image")
                    );
                    $("#chain-modal").css("padding-top", "0px");
                    $("#chain-modal .chain-modal-content").css({
                      height: "100vh",
                      margin: "0",
                      border: "0px",
                      "border-radius": "0px",
                      width: "auto"
                    });
                    $(".chain-modal-content .chain-modal-header").css(
                      "height",
                      "9%"
                    );
                    // $(".chain-modal-content .chain-modal-footer").css(
                    //   "height",
                    //   "9%"
                    // );
                    $(".chain-modal-content .chain-modal-footer").css({"height": "9%", "position": "fixed","width":"100%", "bottom": 0});
                    // $(".chain-modal-content #content").css(
                    //   "max-height",
                    //   "calc(100% - 18%)"
                    // );
                    $(".chain-modal-content #content").css({"max-height":"calc(100% - 18%)","height":"100% !important"});
                    // $(".chain-modal-content #content").addClass('noHeightCss');
                  }, 15);
                }, 1000);
              } else {
                $("#upload-file").removeClass("disabled loading");
                $("#remove-file").removeClass("disabled");
                $("#upload-progress").removeClass("success");
                $("#upload-progress").addClass("error");
              }
            },
            error: function(jqxhr, status, exception) {
              console.log(exception, status, jqxhr);
            }
          });

    // console.log("hp");
  }

  takeSnapshot(websiteUrl) {
    $("#snapshot-button").addClass("loading");
    var _this = this;
    $.blockUI({
      message: this.t(
        this.dataI18nKeys.wait_msg,
        "Taking snapshot, Please wait for some time"
      )
    });
    var xhr = $.ajax({
      type: "post",
      url: site_url + "/chain/snapshot",
      dataType: "json",
      data: { url: websiteUrl },
      timeout: 60000, // 60 secs
      success: function(response) {
        var content, footer;
        if (response.success) {
          var onSave = e => _this.previewSnapshot(e, response.path);
          var onCancel = () => _this.props.closeModal();
          var [c, f, afterDisplaying] = _this.highlightBox(
            response.path,
            onSave,
            onCancel
          );
          content = c;
          footer = f;
          afterDisplaying();
        } else {
          content = (
            <h1>
              {_this.t(
                _this.dataI18nKeys.no_snapshot_message,
                "Snapshot could not be taken. Try again later!"
              )}
            </h1>
          );
          footer = "";
        }
        _this.props.showSnapshotModal(
          _this.t(_this.dataI18nKeys.snapshot),
          content,
          footer
        );
        $("#snapshot-button").removeClass("loading");
        $.unblockUI();
      },
      error: function(jqxhr, status, exception) {
        console.log(exception, status, jqxhr);
        $("#snapshot-button").removeClass("loading");
        $.unblockUI();
        if (status === "timeout") {
          alert(
            _this.t(_this.dataI18nKeys.timeout, "Time out! Try again later!")
          );
        }
      }
    });
  }

  highlightBox(imageUrl, onSave, onCancel, allImages) {
    // console.log("imageUrl");
    // console.log(imageUrl);
    // console.log("allImages");
    // console.log(allImages);
    var _this = this;
    var imgUrl = site_url + "/" + imageUrl + "?q=" + new Date().getTime();
    var loaderImage = site_url + "/img/loading.gif";
    var snapshotImageStyle = {
      backgroundImage: "url(" + imgUrl + ")",
      backgroundSize: "contain"
    };
    // below is not syntax error, it's a bug in netbeans
    var content = (
      <div id="snapshot-modal">
        <img src={loaderImage} id="page-loader" className="page-loader" />
        <div id="snapshot-image" style={snapshotImageStyle} draggable="true" >
          <img src={imgUrl} id="snapshot-img-placeholder" draggable="true" />
        </div>
      </div>
    );
    var footer = (
      <div className="ui form">
        <div className="fields" id="snapshot-preview-form">
          <div className="field action">
            <button
              className="ui primary button"
              id="preview-snapshot"
              onClick={onSave}
            >
              {this.t(this.dataI18nKeys.save, "Save")}
            </button>
          </div>
          <div className="field action">
            <button
              className="ui negative button"
              id="cancel-preview-snapshot"
              onClick={onCancel}
            >
              {this.t(this.dataI18nKeys.close, "Close")}
            </button>
          </div>
        </div>
        <span id="highlight-msg"></span>
      </div>
    );
    var afterDisplaying = () => {
      setTimeout(function() {
        // add image highlight
        globalFunctions.addHighImageHighlight(
          $("#snapshot-modal #snapshot-image")
        );
        $("#chain-modal").css("padding-top", "0px");
        $("#chain-modal .chain-modal-content").css({
          height: "100vh",
          margin: "0",
          border: "0px",
          "border-radius": "0px",
          width: "auto"
        });
        $(".chain-modal-content .chain-modal-header").css("height", "9%");
        $(".chain-modal-content .chain-modal-footer").css("height", "9%");
        $(".chain-modal-content #content").css({
          textAlign: "center",
          maxHeight: "calc(100% - 18%)",
          padding: "0px",
          position: "relative",
          backgroundColor: "#999999",
          height:"100% !important"
        });
        // $(".chain-modal-content #content").addClass('noHeightCss');

        if(allImages != undefined){
          $("#chain-modal .chain-modal-header").append(
            '<div style="width:100%;text-align:center;position: absolute;top: 10px;"><select id="page-dropdown" style="height:100%;" class="ui dropdown page-dropdown"></select></div>'
          );
        
          var select = document.getElementById("page-dropdown");

          for (var i = 0; i < allImages.length; i++) {
            var opt = allImages[i];
            var pageNumber = i + 1;
            var el = document.createElement("option");
            el.id = opt.name;
            el.textContent = "Page " + pageNumber;
            el.value = opt.id;
            select.appendChild(el);
          }
          if (allImages.length > 1) {
            $("#page-dropdown").removeClass("hidden");
          } else {
            $("#page-dropdown").addClass("hidden");
          }
        }
        $("select#page-dropdown").on("change", function(e) {
          console.log("Downloading Image");
          $("img#page-loader").css("display", "block");
          var fileId = this.value;
          console.log("fileId:" + fileId);
          var prevFileId = "";
          var nextFileId = "";
          if ($("select#page-dropdown option:selected").prev().length > 0) {
            prevFileId = $("select#page-dropdown option:selected")
              .prev()
              .val();
            console.log("prevFileId:" + prevFileId);
          }
          if ($("select#page-dropdown option:selected").next().length > 0) {
            nextFileId = $("select#page-dropdown option:selected")
              .next()
              .val();
            console.log("nextFileId:" + nextFileId);
          }

          $.ajax({
            type: "post",
            url: site_url + "/chain/download-image",
            dataType: "json",
            data: { id: fileId, prevId: prevFileId, nextId: nextFileId },
            success: function(response) {
              console.log("Downloading Finish");
              $("img#page-loader").css("display", "none");
              if (response.success) {
                var newImage =
                  site_url +
                  "/" +
                  response.imagePath +
                  "?q=" +
                  new Date().getTime();
                $("div#snapshot-image").css(
                  "background-image",
                  "url(" + newImage + ")"
                );
                $("img#snapshot-img-placeholder").attr("src", newImage);
              }
            },
            error: function(jqxhr, status, exception) {
              console.log("Downloading Error");
              $("img#page-loader").css("display", "none");
              // console.log(exception, status, jqxhr);
              $("#preview-snapshot").removeClass("loading");
              $("#cancel-preview-snapshot").removeClass("disabled");

              // _this.props.closeModal();
            }
          });
        });
      }, 15);
    };
    return [content, footer, afterDisplaying];
  }

  getHighlightAttributes() {
    var top = parseInt($(".rect,.single-resizer,.StyledRect-ybeBY,.bVILeC").css("top"));
    var height = parseInt($(".rect,.single-resizer,.StyledRect-ybeBY,.bVILeC").css("height"));
    var width = parseInt($(".rect,.single-resizer,.StyledRect-ybeBY,.bVILeC").css("width"));
    var left = parseInt($(".rect,.single-resizer,.StyledRect-ybeBY,.bVILeC").css("left"));
    var actualHeight = document.getElementById("snapshot-img-placeholder")
      .naturalHeight;
    var actualWidth = document.getElementById("snapshot-img-placeholder")
      .naturalWidth;
    var htmlHeight = parseFloat($("#snapshot-img-placeholder").css("height"));
    var heightRatio = actualHeight / htmlHeight; // maintain ratio

    var htmlWidth = parseFloat($("#snapshot-img-placeholder").css("width"));
    var widthRatio = actualWidth / htmlWidth; // maintain ratio

    top = Math.round(top * heightRatio);
    height = Math.round(height * heightRatio);
    left = Math.round(left * widthRatio);
    width = Math.round(width * widthRatio);
    return [top, height, width, left];
  }

  previewSnapshot(e, snapshotPath) {
    var _this = this;
    this.props.toggleModalCloseIcon(true);
    var sourceId = this.props.data.viewId;
    var [top, height] = this.getHighlightAttributes();
    $("#preview-snapshot").addClass("loading");
    $("#cancel-preview-snapshot").addClass("disabled");
    $.ajax({
      type: "post",
      url: site_url + "/chain/preview-snapshot",
      dataType: "json",
      data: { path: snapshotPath, top: top, height: height },
      success: function(response) {
        var className = response.success ? "success" : "error";
        if (response.success) {
          var helpTitle = _this.t(
            _this.dataI18nKeys.copyright_hint,
            "Add copyright info, if applicable"
          );
          var copyright = _this.t(
            _this.dataI18nKeys.copyright_placeholder,
            "Copyright"
          );
          $("#preview-snapshot")
            .removeClass("loading")
            .addClass("disabled");
          $("#snapshot-modal").html(
            '<img id="with-highlight" src=' +
              (site_url + "/" + response.imagePath) +
              ">"
          );
          $("#chain-modal .chain-modal-footer").html(
            '<div id="snapshot-date-time">' +
              "Snapshot taken at:" +
              response.dateTime +
              "</div>" +
              '<div class="ui form">' +
              '<div class="fields" id="copyright-form">' +
              '<div class="field" id="copyright">' +
              '<label style="text-align: left;">' +
              copyright +
              "</label>" +
              '<input type="text" title="' +
              helpTitle +
              '" placeholder="' +
              copyright +
              '" />' +
              "</div>" +
              '<div class="field action">' +
              '<button class="ui primary button" id="store-snapshot">' +
              _this.t(_this.dataI18nKeys.save, "Save") +
              "</button>" +
              "</div>" +
              '<div class="field action">' +
              '<button class="ui negative button" id="cancel-store-snapshot">' +
              _this.t(_this.dataI18nKeys.close, "Close") +
              "</button>" +
              "</div>" +
              '<input type="hidden" name="snapshot-date-time" value="' +
              response.dateTime +
              '" />' +
              '<input type="hidden" name="snapshot-belongs-to" value="' +
              sourceId +
              '" />' +
              '<input type="hidden" name="snapshot-path" value="' +
              snapshotPath +
              '" />' +
              '<input type="hidden" name="top-height" value="' +
              top +
              '" />' +
              "</div>" +
              '<div id="copyright-msg"></div>' +
              "</div>"
          );
          $(".chain-modal-content .chain-modal-header").css("height", "9%");
          $(".chain-modal-content .chain-modal-footer").css("height", "18%");
          $(".chain-modal-content #content").css(
            "max-height",
            "calc(100% - 27%)"
          );
          $(".chain-modal-content #content").addClass('noHeightCss');
        } else {
          $("#highlight-msg")
            .addClass(className)
            .text(response.message);
          $("#preview-snapshot").removeClass("loading");
          $("#cancel-preview-snapshot").removeClass("disabled");
        }
        _this.props.toggleModalCloseIcon(false);
      },
      error: function(jqxhr, status, exception) {
        // console.log(exception, status, jqxhr);
        $("#preview-snapshot").removeClass("loading");
        $("#cancel-preview-snapshot").removeClass("disabled");

        // _this.props.closeModal();
      }
    });
  }

  showUploadedFile(e, url) {
    e.preventDefault();
    e.stopPropagation();
    const typeId = this.props.data.typeId;
    const header =
      typeId === 6 || typeId === 9 || typeId === 10 || typeId === 11
        ? this.dataI18nKeys.snapshot
        : this.dataI18nKeys.uploaded_file;
    const fallbackText = typeId === 6 || typeId === 9 || typeId === 10 || typeId === 11 ? "Snapshot" : "Uploaded file";
    const scrollHeight = _.get(
      this.props.data,
      "sourceData.Highlight Height",
      0
    );

    const hideShareButton = false;
    var n = url.lastIndexOf('/');
    var UploadString = url.substring(n + 1);
    const redirectUrl = this.props.data.viewId + '/' + UploadString;
    const archiveURL = this.props.data.viewId + "?url=" + _.get(this.props.data, "sourceData.Url", "");
    
    this.props.showUploadedImage(
      this.t(header, fallbackText),
      <img
        className="uploaded-file"
        src={site_url + "/" + url + "?q=" + new Date().getTime()}
      />,
      scrollHeight,
      hideShareButton,
      redirectUrl,
      archiveURL
    );

    setTimeout(function() {
      $(".uploaded-file")
        .parents("#content")
        .css({
          textAlign: "center",
          maxHeight: "90%",
          padding: "0px",
          position: "relative",
          backgroundColor: "#999999"
        });
      $(".uploaded-file")
        .parents(".chain-modal-content")
        .css({
          height: "100%",
          width: "100%",
          borderRadius: "0px",
          border: "0px"
        });
      $(".uploaded-file")
        .parents("#chain-modal")
        .css("padding-top", "0px");
    }, 1);
  }
  
  showUploadedArchiveFile(e, neededUrl, urlForModal) {
    e.preventDefault();
    e.stopPropagation();
    const typeId = this.props.data.typeId;
    const header =
      typeId === 6 || typeId === 9 || typeId === 10 || typeId === 11
        ? this.dataI18nKeys.snapshot
        : this.dataI18nKeys.uploaded_file;
    const fallbackText = typeId === 6 || typeId === 9 || typeId === 10 || typeId === 11 ? "Snapshot" : "Uploaded file";
    const scrollHeight = _.get(
      this.props.data,
      "sourceData.Highlight Height",
      0
    );

    const hideShareButton = false;
    
    var n = urlForModal.lastIndexOf('/');
    var UploadString = urlForModal.substring(n + 1);
    // const redirectUrl = this.props.data.viewId + '/' + UploadString;
    const redirectUrl = this.props.data.viewId + '/' + urlForModal;
    this.props.showUploadedImage(
      this.t(header, fallbackText),
      // <img
      //   className="uploaded-file"
      //   src={site_url + "/" + url + "?q=" + new Date().getTime()}
      // />,
      <iframe className="uploaded-file" src={site_url + "/" + neededUrl} style={{height : '100%', width : '100%'}}></iframe>,
      scrollHeight,
      hideShareButton,
      redirectUrl
    );
    window.history.replaceState(window.location.href,'ObjURL',urlForModal);
    setTimeout(function() {
      $(".uploaded-file")
        .parents("#content")
        .css({
          textAlign: "center",
          maxHeight: "90%",
          padding: "0px",
          position: "relative",
          backgroundColor: "#999999"
        });
      $(".uploaded-file")
        .parents(".chain-modal-content")
        .css({
          height: "100%",
          width: "100%",
          borderRadius: "0px",
          border: "0px"
        });
      $(".uploaded-file")
        .parents("#chain-modal")
        .css("padding-top", "0px");
    }, 1);
  }

  showUploadedFileLink(uploadedFileObj) {
    const typeId = this.props.data.typeId;
    if (uploadedFileObj === null || [6, 9, 10, 11].includes(typeId)) {
      return null;
    }
    if (typeof uploadedFileObj.not_uploaded !== "undefined") {
      return uploadedFileObj.not_uploaded;
    }
    if (typeof uploadedFileObj.url !== "undefined") {
      let date_format = $('input[name=date_format]').val();
      let formattedDate = '';
      if(date_format == 0){
        formattedDate = moment(uploadedFileObj.uploaded_at).format("MM-DD-YYYY HH:mm:ss");
      }else if(date_format == 1){
        formattedDate = moment(uploadedFileObj.uploaded_at).format("YYYY-MM-DD HH:mm:ss");
      }
      return (
        <div>
            {/* <div>
              <p>{this.t(this.dataI18nKeys.uploaded_file, "Uploaded File")}:</p>
              <a
                onClick={e => this.showUploadedFile(e, uploadedFileObj.url)}
                href=""
              >
                {uploadedFileObj.url.split("/")[1].split(".")[0]}
              </a>
            </div> */}

            {/* <div>
              <p>{this.t(this.dataI18nKeys.uploaded_at, "Uploaded")}:</p>
              <p>{moment(uploadedFileObj.uploaded_at).valueOf()} UTC</p>
            </div> */}

            {/* <div>
              <p>{this.t(this.dataI18nKeys.file_size, "File Size")}:</p>
              <p>{uploadedFileObj.file_size}</p>
            </div> */}

            <div class="ref-detail right-detail">
              <div class="ref-title">
                <span>{this.t(this.dataI18nKeys.uploaded_file, "Uploaded File")}</span>
              </div>
              <div class="ref-text">
                <p><a
                onClick={e => this.showUploadedFile(e, uploadedFileObj.url)}
                href=""
              >
                {uploadedFileObj.url.split("/")[1].split(".")[0]}
              </a></p>
              </div>
            </div>

            <div class="ref-detail right-detail">
              <div class="ref-title">
                <span>{this.t(this.dataI18nKeys.uploaded_at, "Uploaded")}</span>
              </div>
              <div class="ref-text">
                <p>{formattedDate} UTC</p>
              </div>
            </div>

            <div class="ref-detail right-detail">
              <div class="ref-title">
                <span>{this.t(this.dataI18nKeys.file_size, "File Size")}</span>
              </div>
              <div class="ref-text">
                <p>{uploadedFileObj.file_size}</p>
              </div>
            </div>

            
        </div>
      );
    }
  }
  showUploadedFileIconLink(uploadedFileObj) {
    if (uploadedFileObj === null) {
      return null;
    }
    if (typeof uploadedFileObj.not_uploaded !== "undefined") {
      return uploadedFileObj.not_uploaded;
    }
    if (typeof uploadedFileObj.url !== "undefined" && (this.props.data.typeId != 6 && this.props.data.typeId != 9 && this.props.data.typeId != 11 && this.props.data.typeId != 10)) {
      return (
        <div>
          {/* <a
            id={uploadedFileObj.url.split("/")[1].split(".")[0]+"___"+this.props.data.viewId}
            onClick={e => this.showUploadedFile(e, uploadedFileObj.url)}
            href=""
          > */}
          <a
            id={uploadedFileObj.url.split("/")[1].split(".")[0]+"___"+this.props.data.viewId}
          >
            {/* <i className="file alternate outline icon"></i> */} 
            <span class="archiveSpan">Archive</span>
          </a>
        </div>
      );
    }
  }
  showComment() {
    let comment = _.get(this.props.data, "sourceData.Comment", null);
    if (comment === null) {
      return "";
    }
    return (
      <div>
        <p>
          {this.t(
            this.dataI18nKeys.comments_from_the_author,
            "Comments from the author"
          )}
          :
        </p>
        <p>{comment}</p>
      </div>
    );
  }
  showMediaArchiveInfo(mediaArchive) {
    const url = _.get(this.props.data, "sourceData.Url", "");
    if (mediaArchive === null || mediaArchive === undefined) {
      return (
        <div>No archive</div>
      );
    }
    if (mediaArchive.status === "completed" && mediaArchive.setCitation === 0 && mediaArchive.errorMessage === null) {
      return (
        <div>
          <div>
              {/* <p><b>Website archived</b></p> */}
              <a href="" onClick={e => this.setCitation(e)}>Set citation</a>
          </div>
          <a href="" onClick={e => this.viewMediaArchive(e)}>
          </a> <br></br>
          {this.showMediaArchiveDetails(mediaArchive.setCitation)}
        </div>
      );
    }
    if (mediaArchive.status === "completed" && mediaArchive.setCitation === 1 && mediaArchive.errorMessage === null) {
      return (
        <div>
          <div>
              <a href="" onClick={e => this.showUploadedFile(e, this.props.data.uploadedFile.url)}>View webarchive</a>
          </div>
          <a href="" onClick={e => this.viewMediaArchive(e)}>
          </a> <br></br>
          {this.showMediaArchiveDetails(mediaArchive.setCitation)}
        </div>
      );
    }
    if (mediaArchive.status === "completed" && mediaArchive.errorMessage !== null) {
      return (
        <div>Archive failed</div>
      );
    }
    if (mediaArchive.status === "cancel" && mediaArchive.errorMessage === null && this.props.isLoggedIn == 1) {
      
      const id = this.props.data.id;
      return (
        <div>
          {/* <div>
              <p><b>Website archived</b></p>
          </div> */}
          <div>{url} 
          <a href="" onClick={e => this.createMediaArchive(id, url)}><span style={{marginLeft: "20px"}}>Retake</span></a></div>
        </div>
      );
    }
    return (
        <div>
          <div>Archiving in progress <i className="spinner loading icon"></i> <a style={{cursor : "pointer"}} onClick={e => this.cancelMediaArchive(e)}>Cancel</a> </div>
          <br></br>
          {url}
        </div>
      );
  }

  // Set HTML structure for object 
  setObjectDataHTML(type,data) {
    // console.log(data);
    // console.log('<div><div class="ref-title"><span>Start</span></div><div class="ref-text"><p>Start Page Number: '+data['Start Page Number']+'</p><p>From section: 1</p></div></div>');

    switch(type) {

      case 'Article - In Print': case 'Book': case 'Essay':
         return (
          <div>
            <div class="ref-detail">
              <div class="ref-title">
                <span>Start</span>
              </div>
              <div class="ref-text">
                <p>Page Number {data['Start Page Number']}</p>
                <p>From section {data['From section']}</p>
              </div>
            </div>

            <div class="ref-detail">
              <div class="ref-title">
                <span>End</span>
              </div>
              <div class="ref-text endPage">
                <p>Page Number {data['End Page Number']}</p>
                <p>To section {data['To section']}</p>
              </div>
            </div>

            <div class="ref-detail">
              <div class="ref-title">
                  <span>Total page count: </span>
                </div>
                <div class="ref-text">
                  <p>{data['Total page count']}</p>
                </div>
            </div>

          </div>
        );

      case 'Article - Web':
        return (
          <div>

            <div class="ref-detail">
              <div class="ref-title">
                <span>Start</span>
              </div>
              <div class="ref-text">
                <p>Section {data['Start Section']} </p>
              </div>
            </div>

            <div class="ref-detail">
              <div class="ref-title">
                <span>End</span>
              </div>
              <div class="ref-text endPage">
                <p>Section {data['End Section']} </p>
              </div>
            </div>

          </div>
        );

      case 'Blog':
        if(data.hasOwnProperty('Start Date and Time') && data.hasOwnProperty('End Date and Time')) {
          return (
            <div>
              <div class="ref-detail">
                <div class="ref-title">
                  <span>Start</span>
                </div>
                <div class="ref-text">
                  <p><span class="bold-date-time">Time</span> {data['Start Date and Time']}</p>
                </div>
              </div>

              <div class="ref-detail">
                <div class="ref-title">
                  <span>End</span>
                </div>
                <div class="ref-text endPage">
                  <p><span class="bold-date-time">Time</span> {data['End Date and Time']}</p>
                </div>
              </div>

            </div>
          );
        } else if(data.hasOwnProperty('Start Section') && data.hasOwnProperty('End Section')) {
          return (
            <div>
              <div class="ref-detail">
                <div class="ref-title">
                  <span>Start  </span>
                </div>
                <div class="ref-text">
                  <p>Section {data['Start Section']}</p>
                </div>
              </div>

              <div class="ref-detail">
                <div class="ref-title">
                  <span>End  </span>
                </div>
                <div class="ref-text endPage">
                  <p>Section {data['End Section']}</p>
                </div>
              </div>

            </div>
          );
        }

      case 'Event':
        return (
          <div>
            <div class="ref-detail">
              <div class="ref-title">
                <span>Start</span>
              </div>
              <div class="ref-text">
                <p><span class="bold-date-time">Time</span> {data['Start Date and Time']}</p>
              </div>
            </div>

            <div class="ref-detail">
              <div class="ref-title">
                <span>End</span>
              </div>
              <div class="ref-text endPage">
                <p><span class="bold-date-time">Time</span> {data['End Date and Time']}</p>
              </div>
            </div>

          </div>
        );

      case 'Movie':
        return (
          <div>
            <div class="ref-detail">
              <div class="ref-title">
                <span>Start</span>
              </div>
              <div class="ref-text">
                <p><span class="bold-date-time">Time</span> {data['Start time']}</p>
              </div>
            </div>

            <div class="ref-detail">
              <div class="ref-title">
                <span>End</span>
              </div>
              <div class="ref-text endPage">
                <p><span class="bold-date-time">Time</span> {data['End time']}</p>
              </div>
            </div>

            <div class="ref-detail">
              <div class="ref-title">
                <span>Total Duration</span>
              </div>
              <div class="ref-text">
                <p>{data['Total Duration']}</p>
              </div>
            </div>

          </div>
        );

      case 'Social Media':
        if(data.hasOwnProperty('Start Date and Time') && data.hasOwnProperty('End Date and Time')) {
          return (
            <div>
              <div class="ref-detail">
                <div class="ref-title">
                  <span>Start</span>
                </div>
                <div class="ref-text">
                  <p><span class="bold-date-time">Time</span> {data['Start Date and Time']}</p>
                </div>
              </div>

            {data['End Date and Time'] != '-' &&
              <div class="ref-detail">
                <div class="ref-title">
                  <span>End</span>
                </div>
                <div class="ref-text endPage">
                  <p><span class="bold-date-time">Time</span> {data['End Date and Time']}</p>
                </div>
              </div>
            }
            </div>
          );
        } else if(data.hasOwnProperty('Start Section') && data.hasOwnProperty('End Section')) {
          return (
            <div>
              <div class="ref-detail">
                <div class="ref-title">
                  <span>Start  </span>
                </div>
                <div class="ref-text">
                  <p>Section {data['Start Section']}</p>
                </div>
              </div>

              <div class="ref-detail">
                <div class="ref-title">
                  <span>End  </span>
                </div>
                <div class="ref-text endPage">
                  <p>Section {data['End Section']}</p>
                </div>
              </div>

            </div>
          );
        }
      case 'Opinion' :
        return (
          <div>
              <p><b>Opinion Summary</b></p>
              <p>{data['Opinion Summary']} </p>
          </div>
        );

        case 'Education':
          if(data.hasOwnProperty('Start Date and Time') && data.hasOwnProperty('End Date and Time')) {
            return (
              <div>
                <div class="ref-detail">
                  <div class="ref-title">
                    <span>Start</span>
                  </div>
                  <div class="ref-text">
                    <p><span class="bold-date-time">Time</span> {data['Start Date and Time']}</p>
                  </div>
                </div>
  
                <div class="ref-detail">
                  <div class="ref-title">
                    <span>End</span>
                  </div>
                  <div class="ref-text endPage">
                    <p><span class="bold-date-time">Time</span> {data['End Date and Time']}</p>
                  </div>
                </div>
  
              </div>
            );
          } else if(data.hasOwnProperty('Start Page Number') && data.hasOwnProperty('End Page Number')) {
            return (
              <div>
                <div class="ref-detail">
                  <div class="ref-title">
                    <span>Start</span>
                  </div>
                  <div class="ref-text">
                    <p>Page Number {data['Start Page Number']}</p>
                    <p>From section {data['From section']}</p>
                  </div>
                </div>

                <div class="ref-detail">
                  <div class="ref-title">
                    <span>End</span>
                  </div>
                  <div class="ref-text endPage">
                    <p>Page Number {data['End Page Number']}</p>
                    <p>To section {data['To section']}</p>
                  </div>
                </div>

                <div class="ref-detail">
                  <div class="ref-title">
                      <span>Total page count: </span>
                    </div>
                    <div class="ref-text">
                      <p>{data['Total page count']}</p>
                    </div>
                </div>

              </div>
            );
          }

        case 'Education - Lesson/Lecture':
            if(data.hasOwnProperty('Start Date and Time') && data.hasOwnProperty('End Date and Time') && !data.hasOwnProperty('Number - Single')) {
              return (
                <div>
                  <div class="ref-detail">
                    <div class="ref-title">
                      <span>Start</span>
                    </div>
                    <div class="ref-text">
                      <p><span class="bold-date-time">Time</span> {data['Start Date and Time']}</p>
                    </div>
                  </div>
    
                  <div class="ref-detail">
                    <div class="ref-title">
                      <span>End</span>
                    </div>
                    <div class="ref-text endPage">
                      <p><span class="bold-date-time">Time</span> {data['End Date and Time']}</p>
                    </div>
                  </div>
    
                </div>
              );
            } else if(data.hasOwnProperty('Start Page Number') && data.hasOwnProperty('End Page Number') && !data.hasOwnProperty('Number - Single')) {
              return (
                <div>
                  <div class="ref-detail">
                    <div class="ref-title">
                      <span>Start</span>
                    </div>
                    <div class="ref-text">
                      <p>Page Number {data['Start Page Number']}</p>
                      <p>From section {data['From section']}</p>
                    </div>
                  </div>
  
                  <div class="ref-detail">
                    <div class="ref-title">
                      <span>End</span>
                    </div>
                    <div class="ref-text endPage">
                      <p>Page Number {data['End Page Number']}</p>
                      <p>To section {data['To section']}</p>
                    </div>
                  </div>
  
                  <div class="ref-detail">
                    <div class="ref-title">
                        <span>Total page count: </span>
                      </div>
                      <div class="ref-text">
                        <p>{data['Total page count']}</p>
                      </div>
                  </div>
  
                </div>
              );
          } else if(data.hasOwnProperty('Number - Single')) {
            return (
           <div>
             <div class="ref-detail">
               <div class="ref-title">
                 <span>Number </span>
               </div>
               <div class="ref-text">
                 <p>{data['Number - Single']}</p>
               </div>
             </div>
            
           </div>
           );
           } 

        case 'Education - Experiment':
            if(data.hasOwnProperty('Start Date and Time') && data.hasOwnProperty('End Date and Time') && !data.hasOwnProperty('Number - Single')) {
              return (
                <div>
                  <div class="ref-detail">
                    <div class="ref-title">
                      <span>Start</span>
                    </div>
                    <div class="ref-text">
                      <p><span class="bold-date-time">Time</span> {data['Start Date and Time']}</p>
                    </div>
                  </div>
    
                  <div class="ref-detail">
                    <div class="ref-title">
                      <span>End</span>
                    </div>
                    <div class="ref-text endPage">
                      <p><span class="bold-date-time">Time</span> {data['End Date and Time']}</p>
                    </div>
                  </div>
    
                </div>
              );
            } else if(data.hasOwnProperty('Start Page Number') && data.hasOwnProperty('End Page Number') && !data.hasOwnProperty('Number - Single')) {
              return (
                <div>
                  <div class="ref-detail">
                    <div class="ref-title">
                      <span>Start</span>
                    </div>
                    <div class="ref-text">
                      <p>Page Number {data['Start Page Number']}</p>
                      <p>From section {data['From section']}</p>
                    </div>
                  </div>
  
                  <div class="ref-detail">
                    <div class="ref-title">
                      <span>End</span>
                    </div>
                    <div class="ref-text endPage">
                      <p>Page Number {data['End Page Number']}</p>
                      <p>To section {data['To section']}</p>
                    </div>
                  </div>
  
                  <div class="ref-detail">
                    <div class="ref-title">
                        <span>Total page count: </span>
                      </div>
                      <div class="ref-text">
                        <p>{data['Total page count']}</p>
                      </div>
                  </div>
  
                </div>
              );
            } else if(data.hasOwnProperty('Number - Single')) {
             return (
            <div>
              <div class="ref-detail">
                <div class="ref-title">
                  <span>Number </span>
                </div>
                <div class="ref-text">
                  <p>{data['Number - Single']}</p>
                </div>
              </div>
             
            </div>
            );
            } 
      case 'Website' :
        // return (
        //   <div>
        //       <p><b>Website archived</b></p>
        //   </div>
        // );
      default:
        return false;
    }
  }

  render() {
    var data = this.props.data;
    var index = this.props.index;
    var isOwner = this.props.isOwner;
    var dataTitle = data.type + (data.title ? " - " + data.title : "");
    var referenceTitle =
      this.t(this.dataI18nKeys.reference, "reference");
    var compulsoryInfo = data.compulsoryInfo;
    var introReference = this.props.data.typeId != 5 ? data.reference : '';
    var dataUploadedFile =
      typeof data.uploadedFile !== "undefined" ? data.uploadedFile : null;
    var completeReference = data.reference;
    var sourceData = data.sourceData;
    var DownArrowIcon = site_url + "/img/down-arrow.svg";
    var UpArrowIcon = site_url + "/img/up-arrow.svg";
    var titleIntroBlocks = this.t(
      this.dataI18nKeys.click_to_expand,
      "Click to expand"
    );
    var isSelected = this.isSelected();
    this.generateMenuItems();
    let objSelected = "";
    let refSelected = "";
    let expandedGrid = "";
    let lastSource = "";
    let showComment = false;
    let mediaArchive = data.mediaArchive;
    if (
      this.state.currentView === 2 &&
      this.state.currentInfo === "OBJECT_DATA"
    ) {
      objSelected = "selected ";
      expandedGrid = "expanded ";
      showComment = false;
    } else if (
      this.state.currentView === 2 &&
      this.state.currentInfo === "OBJECT_REFERENCE"
    ) {
      refSelected = "selected ";
      expandedGrid = "expanded ";
      showComment = true;
    }
    if(this.props.index === this.props.totalSources ){
      lastSource = " last ";
    }

    let hideLineClass = "";

    if(this.props.appendStatus == "SourcePoint" && this.props.isOwner == false && lastSource.trim() == "last"){
      hideLineClass = "hide-line";
    }

    let textColOneObj = [];
    let textColTwoObj = [];
    let textColOneRef = [];
    let textColTwoORef = [];
    let sourceMaterial = "";
    let sourceMaterialText = "";
    let firstAuthorFName = "";
    let lastAuthorLName = "";

    if (
      isOwner &&
      (this.props.data.typeId === 1 ||
        this.props.data.typeId === 2 ||
        this.props.data.typeId === 3 || 
        this.props.data.typeId === 4 || 
        this.props.data.typeId === 5 || 
        this.props.data.typeId === 8 ||
        this.props.data.typeId === 12 ||
        this.props.data.typeId === 13 ||
        this.props.data.typeId === 14
        )
    ) {
      sourceMaterial = _.get(
        this.props.data,
        "sourceData.Source Material Type",
        ""
      );
      if (data.uploadedFile.not_uploaded == 'Not uploaded') {
        // sourceMaterial = "";
        // sourceMaterial =
        //   this.t(this.dataI18nKeys.orignal_source_material, "") +
        //   ": -";

        sourceMaterialText = this.t(this.dataI18nKeys.orignal_source_material, "");
      } else {
        // sourceMaterial = sourceMaterial;
        // sourceMaterial =
        //   this.t(this.dataI18nKeys.orignal_source_material, "") +
        //   ": " +
        //   sourceMaterial;

          sourceMaterialText = this.t(this.dataI18nKeys.orignal_source_material, "");
          sourceMaterial =  sourceMaterial;
      }
    }
    if (this.props.data.typeId === 5) {
      // let isUser = _.get(sourceData, "Is User", "");
      // sourceData = Object.assign({ "Your View?": isUser }, sourceData);
      sourceData = _.omit(sourceData, ["Created At", "Updated At", "Is User","Notes","Opinion Summary","Name"]);
    }
    if (this.props.data.typeId === 2) {
        sourceData = _.omit(sourceData, ["Description"]);
    }

    if (this.props.data.typeId === 6 || this.props.data.typeId === 9 || this.props.data.typeId === 10 || this.props.data.typeId === 11) {
      sourceData = _.omit(sourceData, ["Notes"]);
    }
    
    if (this.props.data.typeId === 1 || this.props.data.typeId === 2 || this.props.data.typeId === 9 || this.props.data.typeId === 11 || this.props.data.typeId === 8) { 
      sourceData = _.omit(sourceData, ["Author Firstname","Author Lastname"]);
    }

    let authorArray = sourceData['AuthorDetail'];
    
    sourceData = _.omit(sourceData, ["AuthorDetail","Is Protected", "Highlight Height","Delete Status","Deleted At","Deleted By","Published By","Created By",'Is Author']);
    let sourceDataArr = Object.keys(sourceData);

    /* Array.prototype.push.apply(sourceDataArr,authorArray); 
    if(sourceDataArr.length){
      let halfCount = Math.ceil(sourceDataArr.length / 2);
      sourceDataArr.forEach((label, index) => {
        let addQuots = false;
        if (objSelected === "selected ") {
          if (this.props.data.typeId === 5 && label === "Description") {
            addQuots = true;
          }
        }
        if (label !== "Comment" && label !== "Source Material Type") {
          if (index < 12) {
            // if (index < halfCount && index < 7) {
            textColOneObj.push(
              <p key={"index-" + index}>
                {label} :{" "}
                <span
                  style={{ marginLeft: "4px" }}
                  className={addQuots ? "quotes" : ""}
                >
                  {sourceData[label] ? sourceData[label] : ''}
                </span>
              </p>
            );
          } else {
              textColTwoObj.push(
                <p key={"index-" + index}>
                  {label} :{" "}
                  <span
                    style={{ marginLeft: "4px" }}
                    className={addQuots ? "quotes" : ""}
                  >
                    {sourceData[label] ? sourceData[label] : ''}
                  </span>
                </p>
              );
          }
        }
      })
    } */
    let ebook = "";
    
    if(sourceDataArr.length){
      let halfCount = Math.ceil(sourceDataArr.length / 2);
      sourceDataArr.forEach((label, index) => {
        let addQuots = false;
        if (objSelected === "selected ") {
          if (this.props.data.typeId === 5 && label === "Description") {
            addQuots = true;
          }
        }
        if (label !== "Comment" && label !== "Source Material Type") {
          if (index < 12) {
            // if (index < halfCount && index < 7) {
              textColOneObj.push(
                <p key={"index-" + index}>
                  {label} :{" "}
                  <span
                    style={{ marginLeft: "4px" }}
                    className={addQuots ? "quotes" : ""}
                  >
                    {sourceData[label]}
                  </span>
                </p>
              );
                        
          } else {
              textColTwoObj.push(
                <p key={"index-" + index}>
                  {label} :{" "}
                  <span
                    style={{ marginLeft: "4px" }}
                    className={addQuots ? "quotes" : ""}
                  >
                    {sourceData[label]}
                  </span>
                </p>
              );
          }
        }
        if(label === "Type"){
          ebook = sourceData[label];
        }
      })
    }
    
    if(authorArray) {
      // let mergeLength = 0;
      // if(sourceDataArr.length && authorArray.length) {
      //   mergeLength = sourceDataArr.length + authorArray.length;
      // } else {
      //   mergeLength = authorArray.length;
      // }
      authorArray.forEach((label, index) => {
        if(index === 0){
          firstAuthorFName = label['firstname'];
          lastAuthorLName = label['lastname'];
        }
        if(sourceDataArr.length < 12){
        textColOneObj.push(
          <p className="author-detail-block" key={"index-author-" + index}>
            Author:
                <span
                  style={{ marginLeft: "4px" }}
                >
                  {label['firstname']} {label['lastname']}
                </span>
          </p>
        );
        }else{
          textColTwoObj.push(
            <p className="author-detail-block" key={"index-author-" + index}>
              Author:
                  <span
                    style={{ marginLeft: "4px" }}
                  >
                    {label['firstname']} {label['lastname']}
                  </span>
            </p>
          );
        }
    });
  }

    completeReference = _.omit(completeReference, ["Notes"]);
    textColOneRef = this.setObjectDataHTML(dataTitle,completeReference);
    
    let subStringsArray = ['Start','End','Date','Time','section','page','duration'];
    Object.keys(completeReference).forEach((label, index) => {
      if(subStringsArray.some(v => label.toLowerCase().includes(v.toLowerCase())) || index < Object.keys(completeReference).length / 2) {
        
      } else {
        if(label !== "Number - Single"){
        textColTwoORef.push(
            <p key={"index-" + index}>
            {label} : {completeReference[label]}
            </p>
         
        );
      }
      }
    });

    let isProtected = _.get(this.props.data, "sourceData.Is Protected", "no");
    let isProtectedClass = "";
    if (isProtected === "yes") {
      isProtectedClass = " is_protected";
    } else {
      isProtectedClass = "";
    }
    // console.log(dataUploadedFile.url);
    return (
      <div
        className={
          expandedGrid + "four wide column chain-source" + isProtectedClass
        }
        style={this.props.index !== this.props.totalSources ? (null) : {marginRight: this.props.isLoggedIn == 1 ? 64 : this.props.appendStatus == globalFunctions.objectTypes.END_POINT || this.props.appendStatus == globalFunctions.objectTypes.OPEN_POINT ? 
          64
          :
          -105}} //-28 
        ref={ref => {
          this.ref = ref;
        }}
      >

      <div 
      className = "source-label"
      >
        <span>Source {index}</span>
      </div>
    
      {(lastSource !== "" ) ?
      
        <div
        className = "last-primary"
        style = {expandedGrid !== "" ? 
                  {marginLeft: "91%", backgroundColor: "#FFDD57", height: 20, width: 60, borderRadius: "3px"} 
                  : 
                  isProtectedClass !== "" ?
                    {marginLeft: "77%", backgroundColor: "#FFDD57", height: 20, width: 60, borderRadius: "3px"}
                    :
                    {marginLeft: "88%", backgroundColor: "#FFDD57", height: 20, width: 60, borderRadius: "3px"}
                }
        >
          <center style={{fontSize: 11, paddingTop: "4px", color: "#675922"}}><b>PRIMARY</b></center>
        </div>
      
      :
      
        <div
        className = "last-primary"
        style = {expandedGrid !== "" ? 
                {marginLeft: "91%",  height: 20, width: 60, borderRadius: "3px", visibility: 'hidden'} 
                : 
                {marginLeft: "88%", height: 20, width: 60, borderRadius: "3px", visibility: 'hidden'}}
        >
          <center style={{fontSize: 11, paddingTop: "4px", color: "#675922", display: 'none'}}><b>PRIMARY</b></center>
        </div>
      }

        <div
          className = {"selected-wrap reference-block inner-line " + lastSource+" "+hideLineClass}
          id={this.props.data.viewId}
          onClick={this.selectObject}
          //style={{width: 491}}
        >
          { this.props.data.viewId === (this.props.selectedObjectId) &&
                       <InfoBarHeaderMenu
                            selectedObject={this.props.selectedObject}
                            showModal={this.props.showModal}
                            changeLog={this.changeLogOfSelectedObject()}
                            fetchEditForm={this.props.fetchEditFormMenu}
                            objectInfo={this.objectInfoOfSelectedObject()}
                            hideEdit={
                              !this.props.object.isOwner ||
                              this.selectedChainIsPersonalOpinion() === 1
                            }
                            isOwner={isOwner}
                            isLoggedIn={this.props.object.isLoggedIn}
                            performDelete={this.props.delete}
                            saveAsFavorite={this.saveAsFavorite}
                            isSavedAsFavorite={this.props.object.isSavedAsFavorite}
                            isPublished={this.props.object.actualObjectData.is_published}
                          />
                        }
          <div
            onContextMenu={this.contextMenu}
            className={
              "booking-wrapper" +
              (this.state.currentTab === this.tabs.SOURCE ? " selected" : "")
            }
            onClick={e =>
              {e.preventDefault();
                if (this.state.currentInfo === "OBJECT_REFERENCE"){
                  e.preventDefault();
                }else{
                  this.toggleSourceInfoBox(
                    e,
                    "objectInfoBox",
                    this.info.OBJECT_DATA
                  )
                }
                }
            }
          >
            <div className="data-block">
                
              <div
                className={objSelected + "object-div"}
                title={isSelected ? titleIntroBlocks : ""}
              >
              
                <h5
                  className="clearfix"
                  onClick={e => this.showDetail(this.info.OBJECT_DATA)}
                  onContextMenu={e => this.showDetail(this.info.OBJECT_DATA)}
                >
                  {/* {dataTitle} */}
                  {ebook === 'eBook' ? 'Ebook' : dataTitle}
                </h5>
                <div
                  onClick={e => this.showDetail(this.info.OBJECT_DATA)}
                  onContextMenu={e => this.showDetail(this.info.OBJECT_DATA)}
                  className={"info-div "}
                >
                  {isProtected === "yes" ? (
                    <i className="lock icon pull-right"></i>
                  ) : (
                    ""
                  )}
                  {isProtected === "yes"
                    ? "Source info is source protected"
                    : Object.keys(compulsoryInfo).map((label, index) => {
                      return(
                        <p key={"index-" + index}>
                          {this.shortenString(compulsoryInfo[label])}
                        </p>
                      )}
                      )}
                </div>
              </div>
              {/* { this.props.data.viewId === (this.props.selectedObjectId) &&
                       <InfoBarHeaderMenu
                            selectedObject={this.props.selectedObject}
                            showModal={this.props.showModal}
                            changeLog={this.changeLogOfSelectedObject()}
                            fetchEditForm={this.editFormInfoBar()}
                            objectInfo={this.objectInfoOfSelectedObject()}
                            hideEdit={
                              !this.props.object.isOwner ||
                              this.selectedChainIsPersonalOpinion() === 1
                            }
                            isOwner={isOwner}
                            isLoggedIn={this.props.object.isLoggedIn}
                            performDelete={this.deleteObjectInfoBar()}
                            saveAsFavorite={this.saveAsFavorite}
                            isSavedAsFavorite={this.props.object.isSavedAsFavorite}
                            isPublished={this.props.object.actualObjectData.is_published}
                          />
                        } */}
              {isProtected === "no" ? (
                <div
                  ref={this.wrapperRef}
                  className={refSelected + "object-div"}
                  title={isSelected ? titleIntroBlocks : ""}
                  onClick={e =>{
                    if(this.props.expand){
                    e.preventDefault();
                    }
                      this.toggleSourceInfoBox(
                        e,
                        "referenceInfoBox",
                        this.info.OBJECT_REFERENCE
                      );
                      if(this.props.expand){
                        /*e.stopPropagation();*/
                      }
                    }
                    }
                    onContextMenu={e =>{
                      if(this.props.expand){
                      e.preventDefault();
                      }
                      this.toggleSourceInfoBox(
                        e,
                        "referenceInfoBox",
                        this.info.OBJECT_REFERENCE
                      );
                      if(this.props.expand){
                        /*e.stopPropagation();*/
                      }
                    }
                    }
                >
                  <h5
                    className="clearfix"
                    onClick={e => this.showDetail(this.info.OBJECT_REFERENCE)}
                    onContextMenu={e =>
                      this.showDetail(this.info.OBJECT_REFERENCE)
                    }
                  >
                    {referenceTitle}
                  </h5>
                  <div
                    onClick={e => this.showDetail(this.info.OBJECT_REFERENCE)}
                    onContextMenu={e =>
                      this.showDetail(this.info.OBJECT_REFERENCE)
                    }
                    className={"info-div "}
                  >
                    {Object.keys(introReference).map((label, index) => {
                      if(label === "From section" && this.shortenString(introReference['Start Page Number']) === undefined && this.shortenString(introReference['To section']) !== undefined && this.shortenString(introReference['Number - Single']) === undefined){
                        return(
                          <p key={"index-" + index}>
                            Page {this.shortenString(introReference['Start Page Number'])} to Page {this.shortenString(introReference['End Page Number'])}
                            {/* Section {this.shortenString(introReference['From section'])} to Section {this.shortenString(introReference['To section'])} */}
                          </p>
                        );
                      } else if((label === "From section" && this.shortenString(introReference['Start Page Number']) !== undefined) || label === "Notes"){
                      }
                      else if(label === "Start Page Number" && this.shortenString(introReference['End Page Number']) !== undefined && this.shortenString(introReference['Number - Single']) === undefined){
                        return(
                          <p key={"index-" + index}>
                            Page {this.shortenString(introReference['Start Page Number'])} to Page {this.shortenString(introReference['End Page Number'])}
                          </p>
                        );
                      }
                       else if(label === "Start Date and Time" && this.shortenString(introReference['End Date and Time']) !== undefined && this.shortenString(introReference['End Date and Time']) !== "1970-01-01 00:00:00" && this.shortenString(introReference['End Date and Time']) !== "01-01-1970 00:00:00" && this.shortenString(introReference['Start Date and Time']) !== "1970-01-01 00:00:00" && this.shortenString(introReference['Start Date and Time']) !== "01-01-1970 00:00:00" && this.shortenString(introReference['Number - Single']) === undefined){
                        return(
                          <p key={"index-" + index}>
                            {this.shortenString(introReference['Start Date and Time'])} to <br />{this.shortenString(introReference['End Date and Time'])}
                          </p>
                        );
                      }
                      else if(label === "Start Date and Time" && this.shortenString(introReference['Number - Single']) === undefined && this.shortenString(introReference['Start Date and Time']) !== "1970-01-01 00:00:00" && this.shortenString(introReference['Start Date and Time']) !== "01-01-1970 00:00:00"){
                        return(
                        <p key={"index-" + index}>
                          {this.shortenString(introReference['Start Date and Time'])}
                        </p>
                        );
                      }
                      else if(label === "Start time" &&
                      this.shortenString(introReference['End time']) !== undefined && this.shortenString(introReference['Number - Single']) === undefined){
                        return(
                          <p key={"index-" + index}>
                             to {this.shortenString(introReference['End time'])}
                          </p>
                        );
                      }
                      else if(label === "End Page Number" || label === "To section" || label === "End time" || label === "End Date and Time" || label === "Start" || label === "End"){
                      }
                      else if(label === "Number - Single"){
                        return(
                        <p key={"index-" + index}>
                          Number : {this.shortenString(introReference['Number - Single'])}
                        </p>
                        );
                      }
                      else{
                      // if(label !== "Total Duration" && label !== "Total page count"){
                      //     return(
                      //       <p key={"index-" + index}>
                      //         {label}: {this.shortenString(introReference[label])}
                      //       </p>
                      //     );
                      // }

                      }
                    })}
                    <p>{data.typeId === 5 && _.get(dataUploadedFile, "url", "") !== "" ? 'Uploaded' : ''}</p>
                     {_.get(dataUploadedFile, "url", "") !== "" && (
                      this.showUploadedFileIconLink(dataUploadedFile)
                    )}
                    {(_.get(dataUploadedFile, "url", "") === "" && (data.typeId === 1 ||
                      data.typeId === 2 ||
                      data.typeId === 3 || 
                      data.typeId === 4 || 
                      data.typeId === 8 || 
                      data.typeId === 5 ||
                      data.typeId === 12 ||
                      data.typeId === 13 ||
                      data.typeId === 14) && (
                      "No upload" 
                    ))}
                    {((data.typeId === 6 || data.typeId === 9 || data.typeId === 10 || data.typeId === 11) && (
                      // this.showMediaArchiveInfo(mediaArchive)
                      "Archive" 
                    ))}
                  </div>
                </div>
              ) : (
                ""
              )}

              {/* {this.state.currentView === 2 && ( */}
                <div className="block-name " nodrag="true">
                  {/* <p>Source {index}</p> */}
                  <p>{this.props.data.source}</p>
                </div>
              {/* )} */}

              {isProtected === "no"  && this.state.currentView === this.differentViews["EXPANDED"] ? (
                <img
                  id="detail-block-close"
                  src={UpArrowIcon}
                  onClick={this.collapse}
                  style={{height:30,width:30,paddingLeft: 9,paddingRight: 5}}
                />
              ) : 
              (isProtected === "no"  && <img
                id="detail-block-close"
                src={DownArrowIcon}
                onClick={e =>
                  this.toggleSourceInfoBox(
                    e,
                    "objectInfoBox",
                    this.info.OBJECT_DATA
                  )
                }
                style={{height:30,width:30,paddingLeft: 9,paddingRight: 5}}
              />)}
            </div>
            <div
              ref={this.detailsBlockRef}
              className={
                "detail-block " +
                (this.state.currentView === this.differentViews["EXPANDED"]
                  ? "show"
                  : "hide")
              }
            >
              <hr style={{margin:'12px 0px'}} className="selected-source-box"/>
              <div
                className={
                  "book-block " +
                  (this.isInfoVisible(this.info.OBJECT_DATA) ? "show" : "hide")
                }
                nodrag="true"
              >
                {}
                <div className="ui two column divided grid">
                  <div className="row">
                    <div className="column"><div style={{marginTop:26}}>{textColOneObj}</div></div>
                    <div className="column left-col"><div style={{marginTop:26}}>{textColTwoObj}</div></div>
                  </div>
                </div>
              </div>
              <div
                className={
                  "book-referance " +
                  (this.isInfoVisible(this.info.OBJECT_REFERENCE)
                    ? "show"
                    : "hide")
                }
                nodrag="true"
              >
                <div className={"ui " + (data.typeId === 6 || data.typeId === 9 || data.typeId === 10 || data.typeId === 11 ? ' ' :'two column divided grid')}>
                  <div className="row">
                    <div className="column">
                    <div style={{marginTop:26}}>
                      {textColOneRef}
                      {data.typeId === 6 || data.typeId === 9 || data.typeId === 10 || data.typeId === 11 ? this.showMediaArchiveInfo(mediaArchive) : '' }
                      {(this.props.isOwner && (data.typeId === 6 || data.typeId === 9 || data.typeId === 10 || data.typeId === 11) && mediaArchive == null) ? this.showMediaArchiveDetails() : ''}
                      </div>
                    </div>
                    <div className="column left-col">
                    <div style={{marginTop:26}}>
                      {textColTwoORef}
                      {this.showUploadedFileLink(dataUploadedFile)}
                      <p></p>

                      <div class="ref-detail right-detail">
                        <div class="ref-title">
                          <span></span>
                        </div>
                        <div class="ref-text">
                          <p></p>
                        </div>
                      </div>
                      {(_.get(dataUploadedFile, "url", "") === "" && (this.showUploadButton()))}
                      {/* {this.showUploadButton()} */}
                      {}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {isOwner ? (
            <i className="left-arrow"></i>
          ) : this.props.index !== this.props.totalSources ? (
            <i className="left-arrow"></i>
          ) : null}
          {isSelected ? <hr className="selected-source" /> : null}
        </div>
        <div className="context-dropdown-container">
          <div className="ui scrolling dropdown">
            <ul className="context-menu menu new-menu"> {this.menuItems} </ul>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/web/js/ChainSource.js